import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpParams } from '@angular/common/http';
import Utils, { BrValidators } from 'src/app/helpers/utils';
import { ApiService } from 'src/app/services/api/api.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { StorageService } from 'src/app/services/storage/storage.service';
import { ToastService } from 'src/app/services/toast/toast.service';
import { MaskPipe } from 'ngx-mask';
import { permission } from 'src/app/data/permissions';

@Component({
  selector: 'app-dashboard-user-list',
  templateUrl: './dashboard-user-list.component.html',
  styleUrls: ['./dashboard-user-list.component.scss'],
})
export class DashboardUserListComponent implements OnInit {
  role: string;

  users: UserApprovalResponse[] = [];
  filteredUsers: UserApprovalResponse[] = [];
  count: number = 0;
  representativeMock = [
    {
      id: 101,
      created_at: '2024-10-12T14:22:00Z',
      completed: true,
      is_approved: true,
      register: {
        id: 9001,
        type: 'PF',
        created_at: '2024-10-12T14:22:00Z',
        approval_version_number: 2,
        approval_version_label: '2ª versão',
        role: {
          applicable: 'representative',
          applicable_display: 'Representante',
          name: 'Representante',
        },
        person: {
          full_name: 'Marina Duarte',
          document: {
            number: '12345678901',
          },
        },
      },
    },
    {
      id: 102,
      created_at: '2024-11-03T09:10:00Z',
      completed: true,
      is_approved: false,
      register: {
        id: 9002,
        type: 'PJ',
        created_at: '2024-11-03T09:10:00Z',
        approval_version_number: 1,
        approval_version_label: '1ª versão',
        role: {
          applicable: 'representative',
          applicable_display: 'Representante',
          name: 'Representante',
        },
        company: {
          corporate_name: 'Norte Logistica LTDA',
          document: {
            number: '12345678000190',
          },
        },
      },
    },
  ] as unknown as UserApprovalResponse[];

  loading = true;
  offset = 0;
  showing_to = 0;
  sortButtonExpanded = false;

  activeTab: 'all' | 'cedente' | 'cotista' | 'prestador' | 'representative' =
    'all';

  // Armazenar filtros separados por aba
  tabFilters: {
    all: any;
    cedente: any;
    cotista: any;
    prestador: any;
    representative: any;
  } = {
    all: null,
    cedente: null,
    cotista: null,
    prestador: null,
    representative: null,
  };

  // Controle de requisições para evitar race conditions
  private requestCounter: number = 0;

  /** Linhas expandidas (tabela interna de role_controls) — chave: register.id ou item.id */
  expandedRows = new Set<string>();

  /** Modal ativar/inativar papel (tabela interna) */
  showPaperStatusModal = false;
  paperStatusSubmitting = false;
  selectedPaperItem: UserApprovalResponse | null = null;
  selectedPaperRole: any = null;
  showRegisterStatusModal = false;
  registerStatusSubmitting = false;
  selectedRegisterItem: UserApprovalResponse | null = null;
  /** Reativação de cadastro: ativar todos os papéis (multi-select desabilitado). */
  registerActivateAllPapers = false;
  /** Itens do app-select múltiplo na reativação com vários papéis. */
  registerActivatePaperSelectItems: SelectItem[] = [];

  // Summary statistics
  loadingSummary = true;
  statistics = {
    aguardando_aprovacao: 0,
    homologados: 0,
    cedente: 0,
    cotista: 0,
    prestador: 0,
    representative: 0,
    active: 0,
    inactive: 0,
    total: 0,
  };

  permissionObj: PermissionValues = {
    canFilter: false,
    canAdd: false,
  };

  newUserModal: boolean = false;

  showFilterModal = false;
  showExportOptions = false;
  exporting = false;

  /**
   * Padrão de Filtros:
   * - hasFilters só deve ser true APÓS aplicar os filtros (método filterData())
   * - NÃO atualizar hasFilters no valueChanges do filterForm
   * - hasFilters deve ser atualizado apenas quando:
   *   1. filterData() executar com sucesso (após a requisição)
   *   2. resetForm() for chamado (define como false)
   *   3. toggleFilterModal() quando há filtros salvos no storage
   *
   * Isso garante que o botão "Limpar filtros" só apareça após os filtros serem realmente aplicados,
   * não apenas quando o usuário está digitando no formulário.
   */
  hasFilters = false;
  appliedFilters: Array<{ label: string; value: string }> = [];

  today = Utils.todayString();

  sendingRequest = false;

  statusOptions: SelectItem[] = [];
  expiredOptions: SelectItem[] = [];
  riskLevelOptions: SelectItem[] = [];

  dataFilters: any = null;
  primaryRoleOptions: SelectItem[] = [];
  roles: Role[] = [];
  selectedApplicable: string = null;
  selectedFilterApplicable: string = null;
  roleOptions: SelectItem[] = [];

  isAccounts = false;

  newUserForm = this.formBuilder.group({
    role: [null, [Validators.required]],
    interest_fund: [null, []],
    document: [null, Validators.required],
    full_name: [null, [Validators.required]],
    email: [null, [Validators.required, Validators.email]],
    agent: [null, []],
  });

  filterForm = this.formBuilder.group({
    name: [null, []],
    document: [null, [Utils.validateCpfCnpj]],
    agent: [null, []],
    status: [null, []],
    expired: [null, []],
    risk_level: [null, []],
    created_from: [null, []],
    created_to: [null, []],
    expiry_from: [null, []],
    expiry_to: [null, []],
    profileConservador: [false],
    profileModerado: [false],
    profileAgressivo: [false],
    profileNaoAplicavel: [false],
    statusEmAprovacao: [false],
    statusEmEdicao: [false],
    statusHomologado: [false],
    statusRejeitado: [false],
    estadoCadastroTodos: [true],
    estadoCadastroAtivo: [false],
    estadoCadastroInativo: [false],
    estadoTodos: [true],
    estadoAtivo: [false],
    estadoInativo: [false],
    has_imported: [null, []],
  });

  /** Formulário do select de papéis (modal reativar cadastro). */
  registerActivatePapersForm = this.formBuilder.group({
    paperIds: [[] as string[]],
  });

  get hasAnyFilterValue(): boolean {
    const values = this.filterForm.value;
    return Object.values(values).some((value: any) => {
      if (value === null || value === '') {
        return false;
      }
      if (Array.isArray(value) && value.length === 0) {
        return false;
      }
      return true;
    });
  }

  get canApplyFilters(): boolean {
    // Verifica se há algum filtro preenchido
    if (!this.hasAnyFilterValue) {
      return false;
    }

    // Verifica se o documento é válido (quando preenchido)
    const documentControl = this.filterForm.controls.document;
    if (documentControl.value && documentControl.invalid) {
      return false;
    }

    return true;
  }

  /** Seleção única: Estado do cadastro (Todos / Ativo / Inativo). */
  onEstadoCadastroChange(opcao: 'todos' | 'ativo' | 'inativo') {
    this.filterForm.patchValue(
      {
        estadoCadastroTodos: opcao === 'todos',
        estadoCadastroAtivo: opcao === 'ativo',
        estadoCadastroInativo: opcao === 'inativo',
      },
      { emitEvent: false },
    );
  }

  /** Seleção única: Estado dos papéis (Todos / Ativo / Inativo). */
  onEstadoPapeisChange(opcao: 'todos' | 'ativo' | 'inativo') {
    this.filterForm.patchValue(
      {
        estadoTodos: opcao === 'todos',
        estadoAtivo: opcao === 'ativo',
        estadoInativo: opcao === 'inativo',
      },
      { emitEvent: false },
    );
  }

  visible_accounts: any[] = [];
  accounts: RegisterUserResponse[] = [];
  visibleAccountsLoaded = false;

  fundOptions: SelectItem[] = [];
  loadingFunds = true;
  isCnpjDocument = false;

  // Controle de validação de documento
  checkingDocument: boolean = false;
  documentExists: boolean | null = null;
  availablePapers: any[] = [];
  currentPapers: any[] = [];
  currentRole: any[] = [];
  userName: string = '';

  // Controle de colaborador
  isCollaborator: boolean = false;
  collaboratorInfo: any = null;
  collaboratorMessage: string = '';

  selectedNewUserApplicable: string = null;

  // Controle de verificação de documento (similar ao modal de convite)
  documentInviteError: string = null;
  showOtherFields = false;
  documentVerified = false;
  hasPendingApproval: boolean = false;
  pendingApprovalRole: string = '';
  hasInviteSent: boolean = false;
  inviteStatus: string = '';
  invitedData: any = null;
  hasRoleDraft: boolean = false;
  roleDraftInfo: any = null;
  approvedRoles: any[] = [];
  existingRegisterId: string | null = null; // Armazenar register_id quando documento já existe

  constructor(
    private routeParams: ActivatedRoute,
    private api: ApiService,
    private toast: ToastService,
    private router: Router,
    private authService: AuthService,
    private storageService: StorageService,
    private formBuilder: FormBuilder,
    public maskPipe: MaskPipe,
    private http: HttpClient,
  ) {}

  ngOnInit(): void {
    this.authService.canViewPage(['de_can_view_registers']);

    this.role = this.routeParams.snapshot.params.role?.slice(0, -1);
    // Ativar ambos os loadings no início
    this.loading = true;
    this.loadingSummary = true;
    // Chamar ambos juntos para que os skeletons fiquem visíveis até ambos terminarem
    // Chamar ambos juntos para que os skeletons fiquem visíveis até ambos terminarem
    const initData = async () => {
      await this.getData(undefined, undefined, true);
      this.loading = false;
      this.loadingSummary = false;
    };
    initData();
    this.getRoles();

    this.setAgents();
    this.setPermissions();

    this.getFunds();

    // Inicializar opções de status
    this.statusOptions = [
      { label: 'Homologado', value: 'Homologado' },
      { label: 'Em aprovação', value: 'Em aprovação' },
    ];

    // Inicializar opções de validade
    this.expiredOptions = [
      { label: 'Expirado', value: 'true' },
      { label: 'Não Expirado', value: 'false' },
    ];

    // Inicializar opções de risco
    this.riskLevelOptions = [
      { label: 'Baixo', value: 'baixo' },
      { label: 'Médio', value: 'medio' },
      { label: 'Alto', value: 'alto' },
    ];

    // Limpar campo de agente quando mudar de tab (se não for prestador)
    // Isso é feito no método onTabChange

    this.newUserForm.controls.role.valueChanges.subscribe((value) => {
      const selectedRole = this.roles.find((item) => item.id === Number(value));

      if (selectedRole) {
        this.isCnpjDocument = selectedRole.slug.includes('PJ');

        // Resetar estado do documento (mas não o valor do campo)
        this.documentExists = null;
        this.availablePapers = [];
        this.currentPapers = [];
        this.currentRole = [];
        this.userName = '';
        this.checkingDocument = false;
        this.isCollaborator = false;
        this.collaboratorInfo = null;
        this.collaboratorMessage = '';

        this.selectedApplicable = selectedRole
          ? selectedRole.applicable
          : 'assignor';

        this.selectedNewUserApplicable = selectedRole
          ? selectedRole.applicable
          : 'assignor';

        // Configurar validação do agente para prestador de serviço
        if (this.selectedApplicable === 'provider') {
          this.newUserForm.controls.agent.setValidators([Validators.required]);
        } else {
          this.newUserForm.controls.agent.setValidators([]);
        }

        // Configurar validação do fundo de interesse para cedente e cotista
        if (
          this.selectedApplicable === 'assignor' ||
          this.selectedApplicable === 'shareholder'
        ) {
          this.newUserForm.controls.interest_fund.setValidators([
            Validators.required,
          ]);
        } else {
          this.newUserForm.controls.interest_fund.setValidators([]);
        }

        this.newUserForm.controls.agent.setValue(null);
        this.newUserForm.controls.interest_fund.setValue(null);

        this.newUserForm.controls.agent.updateValueAndValidity();
        this.newUserForm.controls.interest_fund.updateValueAndValidity();
      }
    });

    // Validação de documento - resetar estado ao mudar documento
    this.newUserForm.controls.document.valueChanges.subscribe((value) => {
      const documentClean = value ? value.replace(/[^\d]+/g, '') : '';

      // Resetar estado ao mudar documento
      this.documentExists = null;
      this.availablePapers = [];
      this.currentPapers = [];
      this.currentRole = [];
      this.userName = '';
      this.checkingDocument = false;
      this.isCollaborator = false;
      this.collaboratorInfo = null;
      this.collaboratorMessage = '';
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      this.approvedRoles = [];
      this.documentVerified = false;
      this.showOtherFields = false;
      this.documentInviteError = null;

      // Resetar opções de papéis se documento foi limpo
      if (!documentClean || documentClean.length === 0) {
        this.updatePrimaryRoleOptions();
      }

      // Limpar erros anteriores
      this.newUserForm.controls.document.setErrors(null);

      // Limpar campos quando documento mudar
      this.newUserForm.controls.full_name.setValue(null, { emitEvent: false });
      this.newUserForm.controls.email.setValue(null, { emitEvent: false });
    });

    // this.authService.visibleAccountsFetched.subscribe((accounts) => {
    //   this.visible_accounts = accounts;
    //   this.visibleAccountsLoaded = true;
    // });
  }

  async setAgents() {
    try {
      const res = await this.api.get({
        route: 'api/registration/agent/',
        token: true,
      });

      this.roleOptions = res.map((item: any) => {
        return {
          label: item.name,
          value: item.id,
        };
      });
    } catch (error) {
      console.warn(error);
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    }
  }

  async getRoles() {
    const res = await this.api.get<ApiResponse<Role[]>>({
      route: 'role/',
    });

    const { data } = res;

    this.roles = data;

    const userRoles = data
      .filter(
        (_item) => _item.is_visible && !_item.slug.includes('REPRESENTATIVE'),
      )
      .sort((a, b) => {
        if (a.applicable_display < b.applicable_display) {
          return -1;
        }
        if (a.applicable_display > b.applicable_display) {
          return 1;
        }
        return 0;
      })
      .map((item) => {
        return {
          label: `${item.applicable_display} - ${item.name}`,
          value: String(item.id),
          extra: item.slug,
        };
      });

    this.primaryRoleOptions = userRoles;
  }

  updatePrimaryRoleOptions(documentClean?: string) {
    // Se não tiver documento, usar todos os papéis
    if (!documentClean) {
      const userRoles = this.roles
        .filter(
          (_item) => _item.is_visible && !_item.slug.includes('REPRESENTATIVE'),
        )
        .sort((a, b) => {
          if (a.applicable_display < b.applicable_display) {
            return -1;
          }
          if (a.applicable_display > b.applicable_display) {
            return 1;
          }
          return 0;
        })
        .map((item) => {
          return {
            label: `${item.applicable_display} - ${item.name}`,
            value: String(item.id),
            extra: item.slug,
          };
        });
      this.primaryRoleOptions = userRoles;
      return;
    }

    // Determinar tipo do documento (PF = 11 dígitos, PJ = 14 dígitos)
    const isPF = documentClean.length === 11;
    const isPJ = documentClean.length === 14;

    // Filtrar papéis compatíveis com o tipo do documento
    let filteredRoles = this.roles.filter((_item) => {
      if (!_item.is_visible || _item.slug.includes('REPRESENTATIVE')) {
        return false;
      }

      // Filtrar por tipo: PF ou PJ baseado no slug
      const slugUpper = _item.slug.toUpperCase();
      if (isPF && !slugUpper.includes('PF')) {
        return false;
      }
      if (isPJ && !slugUpper.includes('PJ')) {
        return false;
      }

      return true;
    });

    // Filtrar papéis que o usuário já possui (approvedRoles)
    if (this.approvedRoles && this.approvedRoles.length > 0) {
      const approvedRoleIds = this.approvedRoles.map((role) => String(role.id));
      const approvedApplicables = this.approvedRoles.map(
        (role) => role.applicable,
      );

      filteredRoles = filteredRoles.filter((role) => {
        const roleId = String(role.id);
        // Não mostrar se o ID já está aprovado ou se o applicable já está aprovado
        return (
          !approvedRoleIds.includes(roleId) &&
          !approvedApplicables.includes(role.applicable)
        );
      });
    }

    // Ordenar e mapear para SelectItem
    const userRoles = filteredRoles
      .sort((a, b) => {
        if (a.applicable_display < b.applicable_display) {
          return -1;
        }
        if (a.applicable_display > b.applicable_display) {
          return 1;
        }
        return 0;
      })
      .map((item) => {
        return {
          label: `${item.applicable_display} - ${item.name}`,
          value: String(item.id),
          extra: item.slug,
        };
      });

    this.primaryRoleOptions = userRoles;
  }

  changePageData(page: number) {
    // Ativar apenas o loading da listagem (não precisa do summary ao mudar de página)
    this.loading = true;
    this.requestCounter++;
    const currentRequestId = this.requestCounter;
    this.getData(page, currentRequestId);
  }

  /**
   * Determina se o usuário é Master baseado nas regras:
   * - type_permission === "master" OU type_permission === "owner" OU is_approver === true
   */
  isMasterUser(): boolean {
    return this.authService.isMasterUser();
  }

  /**
   * Determina se o usuário é Colaborador Comum baseado nas regras:
   * - type_permission === "common" E (department NÃO é null OU role.applicable === "admin")
   */
  isCommonCollaborator(): boolean {
    return this.authService.isCommonCollaborator();
  }

  /**
   * Verifica se o usuário pode ver a tabela (Master ou Usuário Comum)
   */
  canViewTable(): boolean {
    return this.isMasterUser() || this.isCommonCollaborator();
  }

  async getData(
    page: number = 1,
    requestId?: number,
    activateSummaryLoading: boolean = false,
  ) {
    // Se não foi passado requestId, usar o contador atual (para compatibilidade com outras chamadas)
    const currentRequestId = requestId || ++this.requestCounter;

    // Ativar loading da listagem
    this.loading = true;
    // Ativar loading do summary apenas se solicitado (quando chamado junto com getSummary)
    if (activateSummaryLoading) {
      this.loadingSummary = true;
    }

    const rolesToFilter = [];
    const roles = [
      'assignor',
      'shareholder',
      'provider',
      'representative',
      'fund',
    ];

    // Carregar os filtros da aba atual (se existirem)
    this.loadTabFilters(this.activeTab);

    // Construir filtros a partir do formulário (igual meus cadastros)
    const filters: any = {};
    const values = this.filterForm.value;
    const checkboxKeys = [
      'profileConservador', 'profileModerado', 'profileAgressivo', 'profileNaoAplicavel',
      'statusEmAprovacao', 'statusEmEdicao', 'statusHomologado', 'statusRejeitado',
      'estadoCadastroTodos', 'estadoCadastroAtivo', 'estadoCadastroInativo',
      'estadoTodos', 'estadoAtivo', 'estadoInativo',
    ];

    Object.entries(values).forEach(([key, value]: any) => {
      if (checkboxKeys.includes(key)) return;
      if (value !== null && value !== '' && value !== false) {
        if (key === 'document') {
          filters[key] = Utils.onlyNumbers(value);
        } else if (key === 'status') {
          if (value === 'Homologado') filters.status = 'aprovado';
          else if (value === 'Em aprovação') filters.status = 'em_aprovacao';
          else filters.status = value;
        } else if (key === 'expired') {
          if (value === 'true' || value === true) filters.expired = true;
          else if (value === 'false' || value === false) filters.expired = false;
        } else if (key === 'risk_level') {
          filters.risk_level = value;
        } else if (key === 'has_imported') {
          if (value === true || value === 'true') filters.has_imported = true;
        } else if (
          key === 'created_from' ||
          key === 'created_to' ||
          key === 'expiry_from' ||
          key === 'expiry_to'
        ) {
          // Converter dd/mm/yyyy para yyyy-mm-dd se necessário
          const str = String(value || '').trim();
          if (str && str.includes('/')) {
            const parts = str.split('/');
            if (parts.length === 3) {
              const [d, m, y] = parts;
              filters[key] = `${y}-${m}-${d}`;
            } else {
              filters[key] = value;
            }
          } else if (str) {
            filters[key] = value;
          }
        } else {
          filters[key] = value;
        }
      }
    });

    // Status dos papéis (role_status)
    const roleStatuses: string[] = [];
    if (values.statusEmAprovacao) roleStatuses.push('pending');
    if (values.statusEmEdicao) roleStatuses.push('editing');
    if (values.statusHomologado) roleStatuses.push('homologated');
    if (values.statusRejeitado) roleStatuses.push('rejected');
    if (roleStatuses.length) filters['role_status'] = roleStatuses;

    // Perfil de investimento (investor_profile)
    const profiles: string[] = [];
    if (values.profileConservador) profiles.push('conservative');
    if (values.profileModerado) profiles.push('moderate');
    if (values.profileAgressivo) profiles.push('aggressive');
    if (values.profileNaoAplicavel) profiles.push('not_applicable');
    if (profiles.length) filters['investor_profile'] = profiles;

    // Estado do cadastro (registration_state)
    if (values.estadoCadastroAtivo) filters['registration_state'] = ['active'];
    else if (values.estadoCadastroInativo) filters['registration_state'] = ['inactive'];

    // Estado dos papéis (role_state)
    if (values.estadoAtivo) filters['role_state'] = ['active'];
    else if (values.estadoInativo) filters['role_state'] = ['inactive'];

    const params: any = {
      ...filters,
      page,
      type: 'register',
      return_distinct: true,
      order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
    };

    // Adicionar parâmetro role baseado na tab selecionada
    const roleParam = this.getRoleParam();
    if (roleParam) {
      params.role = roleParam;
    }

    try {
      const response = await this.api.get<ApiResponse<UserApprovalResponse[]>>({
        route: `api/v3/registration/registers/fast/`,
        params,
        token: true,
      });

      // Verificar se esta é a última requisição antes de atualizar os dados
      if (currentRequestId !== this.requestCounter) {
        // Esta requisição não é a mais recente, ignorar resultado
        return;
      }

      const { count, results, offset } = response;
      this.count = count;
      this.offset = offset;
      this.showing_to = (response as any).showing_to || 0;

      // Usar o summary retornado pela API fast (API retorna "representante", não "representative")
      // Total = soma dos 4 cards (cedente + cotista + prestador + representante) no front
      const summary = (response as any).summary;
      if (summary) {
        const cedente = summary.cedente ?? 0;
        const cotista = summary.cotista ?? 0;
        const prestador = summary.prestador ?? 0;
        const representative = summary.representante ?? summary.representative ?? 0;
        const active = summary.active ?? summary.ativos ?? 0;
        const inactive = summary.inactive ?? summary.inativos ?? 0;
        this.statistics = {
          aguardando_aprovacao: summary.aguardando_aprovacao ?? 0,
          homologados: summary.homologados ?? 0,
          cedente,
          cotista,
          prestador,
          representative,
          active,
          inactive,
          total: summary.total ?? 0,
        };
      }

      let filteredResults = results;

      // Se for Master ou Usuário Comum, não filtrar por permissões de role
      // Mostrar todos os dados retornados pela API (já filtrados por role se necessário)
      if (this.canViewTable()) {
        this.users = filteredResults;
      } else {
        // Para outros usuários, manter a lógica de filtragem por permissões
        roles.forEach((role) => {
          const slug = `de_can_view_${role}`;
          if (!this.authService.verifyPermission(slug)) {
            rolesToFilter.push(role);
          }
        });

        const filteredData = filteredResults.filter((item) => {
          return item.register
            ? !rolesToFilter.includes(item.register?.role?.applicable)
            : !rolesToFilter.includes(item.type);
        });

        this.users = filteredData;
        // Atualizar count se houver filtragem por permissões
        if (rolesToFilter.length > 0) {
          this.count = filteredData.length;
        }
      }

      //   this.setModel();
    } catch (error) {
      console.error(error);
      // Se esta não for a última requisição, não fazer nada
      if (currentRequestId !== this.requestCounter) {
        return;
      }
      this.toast.show('error', 'Erro', 'Ocorreu um erro ao carregar os dados.');
    } finally {
      // Só desativar loading se esta for a última requisição
      if (currentRequestId === this.requestCounter) {
        // Se activateSummaryLoading for true, não desativar aqui
        // O finally do Promise.all vai desativar ambos
        if (!activateSummaryLoading) {
          this.loading = false;
        }
      }
    }
  }

  // Carregar os filtros da aba especificada
  loadTabFilters(
    tab: 'all' | 'cedente' | 'cotista' | 'prestador' | 'representative',
  ) {
    const savedFilters = this.tabFilters[tab];

    if (savedFilters) {
      let documentFormatted = null;
      if (savedFilters.document) {
        const docLength = savedFilters.document.length;
        if (docLength === 11) {
          documentFormatted = this.maskPipe.transform(
            savedFilters.document,
            '000.000.000-00',
          );
        } else if (docLength === 14) {
          documentFormatted = this.maskPipe.transform(
            savedFilters.document,
            '00.000.000/0000-00',
          );
        } else {
          documentFormatted = savedFilters.document;
        }
      }

      // Mapear parâmetros da API de volta para os controles do formulário
      const {
        role_status,
        investor_profile,
        registration_state,
        role_state,
        ...rest
      } = savedFilters;

      const roleStatuses = Array.isArray(role_status) ? role_status : [];
      const estadoCadastroTodos = !(
        Array.isArray(registration_state) && registration_state.length > 0
      );
      const estadoCadastroAtivo =
        Array.isArray(registration_state) && registration_state.includes('active');
      const estadoCadastroInativo =
        Array.isArray(registration_state) && registration_state.includes('inactive');
      const estadoTodos = !(Array.isArray(role_state) && role_state.length > 0);
      const estadoAtivo = Array.isArray(role_state) && role_state.includes('active');
      const estadoInativo = Array.isArray(role_state) && role_state.includes('inactive');

      const profiles = Array.isArray(investor_profile) ? investor_profile : [];

      this.filterForm.patchValue({
        ...rest,
        document: documentFormatted,
        statusEmAprovacao: roleStatuses.includes('pending'),
        statusEmEdicao: roleStatuses.includes('editing'),
        statusHomologado: roleStatuses.includes('homologated'),
        statusRejeitado: roleStatuses.includes('rejected'),
        profileConservador: profiles.includes('conservative'),
        profileModerado: profiles.includes('moderate'),
        profileAgressivo: profiles.includes('aggressive'),
        profileNaoAplicavel: profiles.includes('not_applicable'),
        estadoCadastroTodos,
        estadoCadastroAtivo,
        estadoCadastroInativo,
        estadoTodos,
        estadoAtivo,
        estadoInativo,
      });

      this.hasFilters = true;
      this.generateFilterTags(this.filterForm.value);
    } else {
      this.hasFilters = false;
      this.appliedFilters = [];
    }
  }

  /**
   * Retorna o parâmetro role para a API baseado na tab ativa
   */
  getRoleParam(): string | null {
    if (this.activeTab === 'cedente') {
      return 'cedente';
    } else if (this.activeTab === 'cotista') {
      return 'cotista';
    } else if (this.activeTab === 'prestador') {
      return 'prestador';
    } else if (this.activeTab === 'representative') {
      return 'representative';
    }
    // Se for 'all', não adiciona o parâmetro
    return null;
  }

  /**
   * Handler para mudança de tab
   */
  async onTabChange(
    tab: 'all' | 'cedente' | 'cotista' | 'prestador' | 'representative',
  ) {
    // Limpar os filtros da aba atual antes de mudar (não salvar)
    this.tabFilters[this.activeTab] = null;

    // Limpar o formulário antes de mudar de aba
    this.filterForm.reset();

    // Limpar estado de filtros
    this.hasFilters = false;
    this.appliedFilters = [];

    // Ativar ambos os loadings imediatamente
    this.loading = true;
    this.loadingSummary = true;

    // Incrementar contador de requisições
    this.requestCounter++;
    const currentRequestId = this.requestCounter;

    // Mudar para a nova aba
    this.activeTab = tab;

    // Carregar os filtros da nova aba (se existirem)
    this.loadTabFilters(tab);

    // Recarregar dados (a API fast retorna o summary junto com os results)
    await this.getData(1, currentRequestId, true);
    // Desativar ambos após terminarem
    this.loading = false;
    this.loadingSummary = false;
  }

  /**
   * Busca os dados de summary da API
   * IMPORTANTE: Deve usar exatamente os mesmos filtros e parâmetros que getData()
   * para garantir consistência entre o summary e a listagem
   */
  async getSummary(shouldManageLoading: boolean = true) {
    // Sempre ativar loadingSummary quando getSummary for chamado
    // Isso garante que o skeleton fique visível até que a requisição termine
    this.loadingSummary = true;
    try {
      // Carregar os filtros da aba atual (mesmo que getData faz)
      this.loadTabFilters(this.activeTab);

      // Construir filtros a partir do formulário (mesmo processo que getData)
      const filters: any = {};
      const values = this.filterForm.value;
      Object.entries(values).forEach(([key, value]: any) => {
        if (value !== null && value !== '') {
          if (key === 'document') {
            filters[key] = Utils.onlyNumbers(value);
          } else if (key === 'status') {
            // Mapear status do formulário para o valor que a API espera
            if (value === 'Homologado') {
              filters.status = 'aprovado';
            } else if (value === 'Em aprovação') {
              filters.status = 'em_aprovacao';
            } else {
              filters.status = value;
            }
          } else if (key === 'expired') {
            // Converter string 'true'/'false' para boolean
            filters.expired = value === 'true' || value === true;
          } else if (key === 'risk_level') {
            filters.risk_level = value;
          } else if (key === 'has_imported') {
            // Converter boolean para true quando marcado
            filters.has_imported = value === true || value === 'true';
          } else {
            filters[key] = value;
          }
        }
      });

      // Se expired ou risk_level estiverem preenchidos, forçar role=cotista
      if (filters.expired !== undefined || filters.risk_level) {
        filters.role = 'cotista';
      } else {
        // Adicionar parâmetro role baseado na tab selecionada (mesmo que getData)
        const roleParam = this.getRoleParam();
        if (roleParam) {
          filters.role = roleParam;
        }
      }

      // Construir params com os filtros (mesmos parâmetros que getData, exceto page)
      const params: any = {
        ...filters,
        type: 'register',
        return_distinct: true,
        order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
      };

      const { data } = await this.api.get<{
        data: {
          total: number;
          cotista: number;
          cedente: number;
          prestador: number;
          representative?: number;
          representante?: number;
          homologados: number;
          aguardando_aprovacao: number;
        };
      }>({
        route: 'api/v3/registration/registers/summary/',
        params,
        token: true,
      });

      // Total = soma dos 4 cards (cedente + cotista + prestador + representante) no front
      // API retorna "representante"; aceitar também "representative" por compatibilidade
      const cedente = data.cedente ?? 0;
      const cotista = data.cotista ?? 0;
      const prestador = data.prestador ?? 0;
      const representative = data.representante ?? data.representative ?? 0;
      const dataAny = data as any;
      const active = dataAny.active ?? dataAny.ativos ?? 0;
      const inactive = dataAny.inactive ?? dataAny.inativos ?? 0;
      this.statistics = {
        aguardando_aprovacao: data.aguardando_aprovacao ?? 0,
        homologados: data.homologados ?? 0,
        cedente,
        cotista,
        prestador,
        representative,
        active,
        inactive,
        total: dataAny.total ?? 0,
      };
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar os dados de summary.',
      );
    } finally {
      // Só desativar se shouldManageLoading for true
      // Quando chamado junto com getData via Promise.all, o finally do Promise.all vai desativar
      if (shouldManageLoading) {
        this.loadingSummary = false;
      }
    }
  }

  getDisplayName(item: UserApprovalResponse) {
    if (item.register) {
      if (item.register.type && item.register.type.toUpperCase() === 'PF') {
        return item.register.person?.full_name;
      }

      if (item.register.type && item.register.type.toUpperCase() === 'PJ') {
        return item.register.company?.corporate_name;
      }
    }

    if (item.fund) {
      return item.fund.fantasy_name;
    }

    return '';
  }

  getDisplayDocument(item: UserApprovalResponse) {
    if (item.register) {
      if (item.register.type && item.register.type.toUpperCase() === 'PF') {
        return item.register.person.document
          ? 'CPF: ' +
              this.maskPipe.transform(
                item.register.person.document.number,
                '000.000.000-00',
              )
          : '-';
      }

      if (item.register.type && item.register.type.toUpperCase() === 'PJ') {
        return item.register.company.document
          ? 'CNPJ: ' +
              this.maskPipe.transform(
                item.register.company.document.number,
                '00.000.000/0000-00',
              )
          : '-';
      }
    }
    return '';
  }

  formatRoleName(applicable: string): string {
    const name = applicable?.toUpperCase();

    switch (name) {
      case 'ASSIGNOR':
        return 'Cedente';
      case 'SHAREHOLDER':
        return 'Cotista';
      case 'PROVIDER':
        return 'Prestador de Serviço';
      case 'ADMIN':
        return 'Administrador';
      default:
        return 'Representante';
    }
  }

  formatItemName(item: UserApprovalResponse) {
    if (item.register) {
      const register = item.register as any;
      const registerRoles = this.getRegisterRoles(register);

      if (
        this.activeTab === 'representative' ||
        registerRoles.some((role: any) => role?.applicable === 'representative')
      ) {
        return 'Representante';
      }

      // Verificar se há papéis/roles
      if (registerRoles.length > 0) {
        let rolesToDisplay = registerRoles.filter((role: any) => role);

        // Se tiver múltiplos papéis e um deles for representante, remove o representante
        // Exceção: se só tiver representante, exibe ele
        if (rolesToDisplay.length > 1) {
          rolesToDisplay = rolesToDisplay.filter(
            (role: any) => role.applicable !== 'representative',
          );
        }

        // Formatar e juntar
        const roleNames = rolesToDisplay.map((role: any) => {
          if (role.applicable_display) return role.applicable_display;
          return this.formatRoleName(role.applicable);
        });

        if (roleNames.length > 0) {
          return roleNames.join(', ');
        }
      }

    }

    return 'Não identificado';
  }

  getItemSubtitle(item: UserApprovalResponse): string {
    if (item.register) {
      const register = item.register as any;
      const registerRoles = this.getRegisterRoles(register);

      if (
        this.activeTab === 'representative' ||
        registerRoles.some((role: any) => role?.applicable === 'representative')
      ) {
        return register.type === 'PJ' ? 'Pessoa Jurídica' : 'Pessoa Física';
      }

      if (registerRoles.length > 0) {
        // Verificar se algum é provider para mostrar tipo de pessoa
        const hasProvider = registerRoles.some(
          (r: any) => r.applicable === 'provider',
        );

        if (hasProvider) {
          // Se for provider, mostrar tipo de pessoa apenas uma vez
          return register.type === 'PJ' ? 'Pessoa Jurídica' : 'Pessoa Física';
        }

        // Se não for provider, mostrar o nome do primeiro papel (todos são do mesmo tipo)
        return registerRoles[0]?.name || '';
      }

    }

    return '';
  }

  /** Verifica se um role_control está ativo (state === 'active'). */
  private isRoleControlActive(control: any): boolean {
    if (!control) return false;
    const state = (control.state || '').toString().toLowerCase();
    if (state === 'active') return true;
    const status = (control.status || '').toString().toLowerCase();
    if (status === 'active') return true;
    const estado = (control.estado || '').toString();
    return estado === 'Ativo';
  }

  /**
   * Estado na coluna "Estado": origem do valor:
   * 1) register.active (fonte principal enviada pelo backend)
   * 2) status original legado (is_active, registration_state, role_state, estado, state)
   * 3) Se existir role_controls (vários papéis), deriva deles
   * 4) Se não houver dados, considera "Ativo".
   */
  getEstadoAtivoInativo(item: UserApprovalResponse): string {
    const reg = item?.register as any;
    const registerActive = reg?.active;
    if (typeof registerActive === 'boolean') {
      return registerActive ? 'Ativo' : 'Inativo';
    }

    // Prioridade 1: status original retornado pelo backend
    const isActiveBool = (item as any)?.is_active ?? reg?.is_active;
    if (typeof isActiveBool === 'boolean') {
      return isActiveBool ? 'Ativo' : 'Inativo';
    }
    const registrationState = (item as any)?.registration_state ?? reg?.registration_state;
    const roleState = (item as any)?.role_state ?? reg?.role_state;
    const estadoOriginal = (item as any)?.estado ?? reg?.estado;
    const stateOriginal = (item as any)?.state ?? reg?.state;
    const value = registrationState ?? roleState ?? estadoOriginal ?? stateOriginal;
    if (value !== undefined && value !== null && value !== '') {
      const s = Array.isArray(value) ? value[0] : value;
      const str = String(s).toLowerCase();
      return str === 'active' || str === 'ativo' || str === 'activo' ? 'Ativo' : 'Inativo';
    }
    // Prioridade 2: derivar de role_controls quando existir (vários papéis)
    const roleControls = reg?.role_controls ?? (item as any)?.role_controls;
    if (Array.isArray(roleControls) && roleControls.length > 0) {
      const allActive = roleControls.every((c: any) => this.isRoleControlActive(c));
      return allActive ? 'Ativo' : 'Inativo';
    }
    // Prioridade 3: registro com apenas 1 papel (sem role_controls) → Ativo
    return 'Ativo';
  }

  /** Classe do badge da coluna Estado. */
  getEstadoBadgeClass(item: UserApprovalResponse): string {
    return this.getEstadoAtivoInativo(item) === 'Ativo'
      ? 'status-badge status-badge-homologated'
      : 'status-badge status-badge-rejected';
  }

  /**
   * Retorna o array de papéis para exibir como badges na coluna Papel.
   * Usa somente register.papers[].role.
   */
  getRolesForBadges(
    item: UserApprovalResponse,
  ): Array<{ applicable_display?: string; name?: string }> {
    const register = item?.register as any;
    const rolesFromPapers = this.getRegisterRoles(register);
    if (rolesFromPapers.length > 0) {
      let rolesToDisplay = rolesFromPapers.filter(
        (role: any) => role && (role.applicable_display || role.name),
      );
      if (rolesToDisplay.length > 1) {
        rolesToDisplay = rolesToDisplay.filter(
          (role: any) => role.applicable !== 'representative',
        );
      }
      if (rolesToDisplay.length === 0) {
        rolesToDisplay = rolesFromPapers;
      }
      return rolesToDisplay.map((role: any) => {
        const roleName = String(role?.name || '').toUpperCase();
        const roleSlug = String(role?.slug || '').toUpperCase();
        const isShareholderFI =
          role?.applicable === 'shareholder' &&
          (roleName.includes('FI') || roleSlug.includes('-FI'));

        if (isShareholderFI) {
          return {
            ...role,
            applicable_display: 'Cotista Fundo de Investimento',
          };
        }

        return role;
      });
    }
    return [];
  }

  private getRegisterRoles(register: any): any[] {
    if (!register) return [];
    if (Array.isArray(register?.papers) && register.papers.length > 0) {
      return register.papers
        .map((paper: any) => paper?.role)
        .filter((role: any) => role && (role.applicable_display || role.name));
    }
    return [];
  }

  toggleRow(item: UserApprovalResponse) {
    const key = String((item?.register as any)?.id ?? item?.id ?? '');
    if (this.expandedRows.has(key)) {
      this.expandedRows.delete(key);
      return;
    }
    this.expandedRows.add(key);
  }

  isRowExpanded(item: UserApprovalResponse): boolean {
    return this.expandedRows.has(String((item?.register as any)?.id ?? item?.id ?? ''));
  }

  /** Lista de role_controls para a tabela interna (igual meus cadastros). */
  getRoleControlsList(item: UserApprovalResponse): any[] {
    const register = (item?.register as any) ?? {};
    const papers = Array.isArray(register?.papers) ? register.papers : [];

    if (papers.length > 0) {
      const profileValidity =
        register?.investor_profile?.expire_register ??
        register?.registration_expiration_date ??
        register?.investor_profile?.validity ??
        null;
      const registerInvestorProfile =
        register?.investor_profile?.profile_display ??
        register?.investor_profile?.profile ??
        null;

      return papers.map((paper: any) => ({
        ...paper,
        state: paper?.active ? 'active' : 'inactive',
        created_at: paper?.created_at ?? register?.created_at ?? null,
        profile_validity: paper?.profile_validity ?? profileValidity,
        register_investor_profile: registerInvestorProfile,
      }));
    }

    const roleControls = register?.role_controls ?? (item as any)?.role_controls;
    return Array.isArray(roleControls) ? roleControls : [];
  }

  /** Se o papel do role_control é Representante (não mostra botão ativar/inativar). */
  isRepresentativeRoleControl(rc: any): boolean {
    if (!rc) return false;
    const role = rc.role || {};
    const applicable = (role.applicable || '').toString().toLowerCase();
    const slug = (role.slug || '').toString().toLowerCase();
    const name = (role.name || rc.role_name || '').toString().toLowerCase();
    return (
      applicable === 'representative' ||
      slug.includes('representative') ||
      name.includes('representante')
    );
  }

  /** Nome do papel na linha expandida (role_control.role.name ou role_control.role_name). */
  getRoleControlPapelName(rc: any): string {
    const role = rc?.role ?? {};
    const applicable = (role?.applicable || '').toString().toLowerCase();
    const name = (role?.name || rc?.role_name || '').toString();
    const slug = (role?.slug || '').toString().toUpperCase();

    if (applicable === 'shareholder' && (name.toUpperCase().includes('FI') || slug.includes('FI'))) {
      return 'Cotista Fundo de Investimento';
    }

    return role?.applicable_display ?? role?.name ?? rc?.role_name ?? '—';
  }

  /** Status traduzido para exibição na tabela interna. */
  private mapRoleControlStatus(raw?: string): string {
    const normalized = (raw || '').toString().trim().toLowerCase();
    if (/editing|created|em edição|em edicao/.test(normalized)) return 'Em edição';
    if (/pending|in approval|em aprovação|em aprovacao/.test(normalized)) return 'Em aprovação';
    if (/approved|homologated|homologado|aprovado/.test(normalized)) return 'Homologado';
    if (/rejected|rejeitado/.test(normalized)) return 'Rejeitado';
    return raw ? String(raw) : '—';
  }

  getRoleControlStatusDisplay(rc: any): string {
    const raw = rc?.status_display ?? rc?.status;
    return raw ? this.mapRoleControlStatus(raw) : '—';
  }

  getRoleControlStatusClass(rc: any): string {
    const status = this.getRoleControlStatusDisplay(rc).toLowerCase();
    if (/homologado/.test(status)) return 'status-badge status-badge-homologated';
    if (/rejeitado/.test(status)) return 'status-badge status-badge-rejected';
    if (/em aprovação/.test(status)) return 'status-badge status-badge-approval';
    return 'status-badge status-badge-editing';
  }

  getRoleControlProfile(rc: any): string {
    const role = rc?.role ?? {};
    const applicable = (role?.applicable || '').toString().toLowerCase();
    if (applicable === 'shareholder') {
      const shareholderProfile = rc?.register_investor_profile;
      return shareholderProfile ? String(shareholderProfile).trim() : 'Não aplicável';
    }

    const value = rc?.investor_profile ?? rc?.profile ?? '';
    return (value && String(value).trim()) ? String(value).trim() : 'Não aplicável';
  }

  /** Estilo do badge de perfil (Conservador/Moderado/Agressivo/Não aplicável) — mesmas cores de meus cadastros. */
  getRoleControlProfileBadgeStyle(rc: any): { [key: string]: string } {
    const label = this.getRoleControlProfile(rc);
    const normalized = (label || '').toLowerCase().trim();
    let config: { badgeBackgroundColor: string; badgeTextColor: string };
    if (/conservador/.test(normalized)) {
      config = { badgeTextColor: '#0E6027', badgeBackgroundColor: '#A7F0BA' };
    } else if (/moderado/.test(normalized)) {
      config = { badgeTextColor: '#0043CE', badgeBackgroundColor: '#D0E2FF' };
    } else if (/agressivo/.test(normalized)) {
      config = { badgeTextColor: '#A2191F', badgeBackgroundColor: '#FFD7D9' };
    } else {
      // Não aplicável / Não declarado
      config = { badgeTextColor: '#4c4c4c', badgeBackgroundColor: '#ebebeb' };
    }
    return {
      'background-color': config.badgeBackgroundColor,
      color: config.badgeTextColor,
    };
  }

  getRoleControlCreatedAt(rc: any): string {
    const raw = rc?.created_at;
    if (!raw) return '—';

    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '—';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');

    return `${day}/${month}/${year} às ${hours}:${minutes}`;
  }

  getRoleControlValidity(rc: any): string {
    const raw = rc?.profile_validity;
    if (!raw) return '—';

    const date = new Date(raw);
    if (Number.isNaN(date.getTime())) return '—';

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }

  getRoleControlEstado(rc: any): string {
    if (typeof rc?.active === 'boolean') {
      return rc.active ? 'Ativo' : 'Inativo';
    }
    const state = (rc?.state ?? rc?.estado ?? '').toString().trim().toLowerCase();
    if (!state) return '—';
    return state === 'active' || state === 'ativo' ? 'Ativo' : 'Inativo';
  }

  getRoleControlEstadoClass(rc: any): string {
    return this.getRoleControlEstado(rc) === 'Ativo'
      ? 'status-badge status-badge-homologated'
      : 'status-badge status-badge-rejected';
  }

  /** Se o role_control está ativo (state === 'active'). Usado no botão ativar/inativar. */
  isRoleActive(item: UserApprovalResponse, rc: any): boolean {
    if (typeof rc?.active === 'boolean') return rc.active;
    return (rc?.state ?? '').toString().toLowerCase() === 'active';
  }

  getPaperActionTooltip(item: UserApprovalResponse, rc: any): string {
    return this.isRoleActive(item, rc) ? 'Inativar papel' : 'Ativar papel';
  }

  getPaperActionTitle(item: UserApprovalResponse | null, rc: any): string {
    const active = item && rc != null ? this.isRoleActive(item, rc) : false;
    return active ? 'Inativar Papel' : 'Ativar Papel';
  }

  getPaperActionMessage(item: UserApprovalResponse | null, rc: any): string {
    const active = item && rc != null ? this.isRoleActive(item, rc) : false;
    return active
      ? 'Tem certeza que deseja inativar o papel'
      : 'Tem certeza que deseja ativar o papel';
  }

  /** Nome do papel para exibição no modal (role_control.role.name ou role_name). */
  getRoleLabelForModal(rc: any): string {
    return this.getRoleControlPapelName(rc);
  }

  openPaperStatusModal(item: UserApprovalResponse, rc: any) {
    this.selectedPaperItem = item;
    this.selectedPaperRole = rc;
    this.showPaperStatusModal = true;
  }

  onPaperActionClick(event: Event, item: UserApprovalResponse, rc: any) {
    event.preventDefault();
    event.stopPropagation();
    this.openPaperStatusModal(item, rc);
  }

  isRegisterActive(item: UserApprovalResponse | null): boolean {
    const registerActive = (item?.register as any)?.active;
    if (typeof registerActive === 'boolean') return registerActive;
    return this.getEstadoAtivoInativo(item as UserApprovalResponse) === 'Ativo';
  }

  getRegisterActionTooltip(item: UserApprovalResponse): string {
    return this.isRegisterActive(item) ? 'Inativar cadastro' : 'Ativar cadastro';
  }

  getRegisterActionTitle(item: UserApprovalResponse | null): string {
    return this.isRegisterActive(item) ? 'Inativar Cadastro' : 'Ativar Cadastro';
  }

  getRegisterActionMessage(item: UserApprovalResponse | null): string {
    return this.isRegisterActive(item)
      ? 'Tem certeza que deseja inativar o cadastro'
      : 'Tem certeza que deseja ativar o cadastro';
  }

  getRegisterPapersRaw(item: UserApprovalResponse | null): any[] {
    const register = (item?.register as any) ?? {};
    return Array.isArray(register.papers) ? register.papers : [];
  }

  getRegisterPapersForActivation(
    item: UserApprovalResponse | null,
  ): { id: string; label: string }[] {
    return this.getRegisterPapersRaw(item)
      .map((p: any) => ({
        id: p?.id != null ? String(p.id).trim() : '',
        label: this.getRoleControlPapelName(p),
      }))
      .filter((x) => x.id);
  }

  isRegisterActivationSinglePaper(): boolean {
    const item = this.selectedRegisterItem;
    if (!item || this.isRegisterActive(item)) return false;
    return this.getRegisterPapersForActivation(item).length === 1;
  }

  /** Rótulo do único papel na reativação de cadastro (modal com um papel). */
  getSingleRegisterActivationPaperLabel(): string {
    const item = this.selectedRegisterItem;
    if (!item) return '—';
    const papers = this.getRegisterPapersForActivation(item);
    return papers[0]?.label ?? '—';
  }

  isRegisterActivationMultiPaper(): boolean {
    const item = this.selectedRegisterItem;
    if (!item || this.isRegisterActive(item)) return false;
    return this.getRegisterPapersForActivation(item).length > 1;
  }

  isRegisterActivationConfirmDisabled(): boolean {
    if (!this.selectedRegisterItem || this.isRegisterActive(this.selectedRegisterItem)) {
      return false;
    }
    if (!this.isRegisterActivationMultiPaper()) {
      return false;
    }
    if (this.registerActivateAllPapers) {
      return false;
    }
    const raw = this.registerActivatePapersForm.get('paperIds')?.value;
    const ids = Array.isArray(raw) ? raw : [];
    return ids.length === 0;
  }

  onRegisterActivateAllToggle(): void {
    if (this.registerActivateAllPapers) {
      this.registerActivatePapersForm.patchValue({ paperIds: [] });
    }
  }

  onRegisterActionClick(event: Event, item: UserApprovalResponse) {
    event.preventDefault();
    event.stopPropagation();
    this.openRegisterStatusModal(item);
  }

  openRegisterStatusModal(item: UserApprovalResponse) {
    this.selectedRegisterItem = item;
    this.registerActivateAllPapers = false;
    this.registerActivatePaperSelectItems = this.getRegisterPapersForActivation(
      item,
    ).map((p) => ({ label: p.label, value: p.id }));
    this.registerActivatePapersForm.patchValue({ paperIds: [] });
    this.showRegisterStatusModal = true;
  }

  closeRegisterStatusModal() {
    this.showRegisterStatusModal = false;
    this.selectedRegisterItem = null;
    this.registerActivateAllPapers = false;
    this.registerActivatePaperSelectItems = [];
    this.registerActivatePapersForm.patchValue({ paperIds: [] });
  }

  async confirmRegisterStatusChange() {
    const item = this.selectedRegisterItem;
    if (!item?.register?.id) return;

    const registerUuid = String(item.register.id).trim();
    const isInactivating = this.isRegisterActive(item);
    const active = !isInactivating;

    let paperIdsToActivate: string[] = [];
    if (!isInactivating) {
      const papers = this.getRegisterPapersRaw(item);
      if (papers.length === 0) {
        this.toast.show(
          'error',
          'Erro',
          'Nenhum papel encontrado para este cadastro.',
        );
        return;
      }
      if (papers.length === 1) {
        const id = papers[0]?.id != null ? String(papers[0].id).trim() : '';
        if (!id) {
          this.toast.show(
            'error',
            'Erro',
            'Dados insuficientes para ativar o cadastro.',
          );
          return;
        }
        paperIdsToActivate = [id];
      } else {
        if (this.registerActivateAllPapers) {
          paperIdsToActivate = papers
            .map((p: any) => (p?.id != null ? String(p.id).trim() : ''))
            .filter(Boolean);
        } else {
          const raw = this.registerActivatePapersForm.get('paperIds')?.value;
          const ids = Array.isArray(raw) ? raw : [];
          paperIdsToActivate = ids.map((id) => String(id).trim()).filter(Boolean);
        }
        if (paperIdsToActivate.length === 0) {
          return;
        }
      }
    }

    this.closeRegisterStatusModal();
    this.registerStatusSubmitting = true;

    try {
      if (isInactivating) {
        await this.api.patch({
          route: 'api/v3/registration/registers/',
          token: true,
          body: {
            register_uuid: registerUuid,
            active,
          },
        });
        this.toast.show('info', 'Sucesso', 'Cadastro inativado com sucesso.');
      } else {
        const paperResults = await Promise.all(
          paperIdsToActivate.map((paperId) =>
            this.api
              .patch({
                route: `api/v2/registration/registration-papers/${paperId}/`,
                token: true,
                body: { active: true },
              })
              .then(() => ({ ok: true as const }))
              .catch(() => ({ ok: false as const })),
          ),
        );
        const paperFailures = paperResults.filter((r) => !r.ok).length;
        if (paperFailures > 0) {
          this.toast.show(
            'warning',
            'Atenção',
            'Não foi possível concluir todas as ações.',
          );
        }
        try {
          await this.api.patch({
            route: 'api/v3/registration/registers/',
            token: true,
            body: {
              register_uuid: registerUuid,
              active: true,
            },
          });
          if (paperFailures === 0) {
            this.toast.show(
              'info',
              'Sucesso',
              'Cadastro ativado com sucesso.',
            );
          }
        } catch {
          this.toast.show(
            'error',
            'Erro',
            'Não foi possível alterar o status do cadastro. Tente novamente.',
          );
        }
      }

      this.requestCounter++;
      const currentRequestId = this.requestCounter;
      await this.getData(1, currentRequestId, true);
    } catch {
      if (isInactivating) {
        this.toast.show(
          'error',
          'Erro',
          'Não foi possível alterar o status do cadastro. Tente novamente.',
        );
      }
    } finally {
      this.registerStatusSubmitting = false;
      this.loading = false;
      this.loadingSummary = false;
    }
  }

  closePaperStatusModal() {
    this.showPaperStatusModal = false;
    this.selectedPaperItem = null;
    this.selectedPaperRole = null;
  }

  async confirmPaperStatusChange() {
    if (!this.selectedPaperItem || !this.selectedPaperRole) {
      return;
    }

    const rc = this.selectedPaperRole;
    const paperId = rc?.id != null ? String(rc.id).trim() : '';

    if (!paperId) {
      this.toast.show(
        'error',
        'Erro',
        'Dados insuficientes para alterar o status do papel.',
      );
      return;
    }

    const currentlyActive = this.isRoleActive(this.selectedPaperItem, rc);
    const isInactivating = currentlyActive;
    const active = !isInactivating;

    this.paperStatusSubmitting = true;
    try {
      await this.api.patch({
        route: `api/v2/registration/registration-papers/${paperId}/`,
        token: true,
        body: {
          active,
        },
      });
      this.toast.show(
        'info',
        'Sucesso',
        isInactivating ? 'Papel inativado com sucesso.' : 'Papel ativado com sucesso.',
      );
      this.closePaperStatusModal();
      this.requestCounter++;
      const currentRequestId = this.requestCounter;
      await this.getData(1, currentRequestId, true);
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Não foi possível alterar o status do papel. Tente novamente.',
      );
    } finally {
      this.paperStatusSubmitting = false;
      this.loading = false;
      this.loadingSummary = false;
    }
  }

  getStatus(item: UserApprovalResponse) {
    const register = item.register ?? item.fund;

    let last_approval: Approval = item;

    if (last_approval.completed) {
      if (last_approval.is_approved) {
        return 'Aprovado internamente';
      } else {
        return `${register ? 'Cadastro' : 'Fundo'} rejeitado`;
      }
    } else {
      if (last_approval.current_department !== null) {
        return last_approval.current_department.type === 'department'
          ? last_approval.current_department.department?.name
          : last_approval.current_department.agent?.name;
      } else if (last_approval.step === 0) {
        return 'Edição';
      } else {
        return 'Departamento não definido';
      }
    }
  }

  getStatusInfo(item: UserApprovalResponse) {
    const register = item.register ?? item.fund;

    let last_approval: Approval = item;
    if (last_approval.completed) {
      if (last_approval.is_approved) {
        return 'Integração ao fundo';
      } else {
        if (last_approval.current_department !== null) {
          return last_approval.current_department.type === 'department'
            ? last_approval.current_department.department?.name
            : last_approval.current_department.agent?.name;
        } else if (last_approval.step === 0) {
          return 'Edição';
        } else {
          return 'Departamento não definido';
        }
      }
    } else if (last_approval.step === 0) {
      return item.register ? 'Aguardando representantes' : '';
    } else {
      return `Aguardando aprovação (${last_approval.step})`;
    }
  }

  // Método para obter o status formatado (como em dashboard-accounts)
  getStatusForBadge(item: UserApprovalResponse): string {
    // Se for representante, retorna "-"
    if (this.isRepresentative(item)) {
      return '-';
    }

    // Prioridade para o status retornado diretamente pela API (V3)
    if (item.status) {
      const statusLower = item.status.toLowerCase();
      // Capitalizar a primeira letra
      return statusLower.charAt(0).toUpperCase() + statusLower.slice(1);
    }

    if (item.register?.current_stage) {
      const currentStage = item.register.current_stage;

      // Normalizar os valores
      if (currentStage === 'Em edição' || currentStage === 'Em edicao') {
        return 'Em edição';
      }
      if (currentStage === 'Em aprovação' || currentStage === 'Em aprovacao') {
        return 'Em aprovação';
      }
      if (currentStage === 'Homologado' || currentStage === 'Aprovado') {
        return 'Homologado';
      }
      if (currentStage === 'Rejeitado') {
        return 'Rejeitado';
      }
      return currentStage;
    }

    // Fallback para lógica antiga
    let last_approval: Approval = item;
    if (last_approval.completed) {
      if (last_approval.is_approved) {
        return 'Homologado';
      } else {
        return 'Rejeitado';
      }
    } else {
      if (last_approval.step === 0) {
        return 'Em edição';
      } else {
        return 'Em aprovação';
      }
    }
  }

  // Método para obter a classe CSS do badge de status
  getStatusBadgeClass(item: UserApprovalResponse): string {
    const status = this.getStatusForBadge(item);

    if (status === '-') {
      return 'status-badge-none';
    } else if (status === 'Homologado' || status === 'Aprovado') {
      return 'status-badge-homologated';
    } else if (status === 'Em aprovação') {
      return 'status-badge-approval';
    } else if (status === 'Em edição') {
      return 'status-badge-editing';
    } else if (status === 'Rejeitado') {
      return 'status-badge-rejected';
    }
    return 'status-badge-editing';
  }

  // Método para obter informações de aprovação (departamento/agente)
  getApprovalInfo(item: UserApprovalResponse): string {
    const status = this.getStatusForBadge(item);

    if (status === 'Rejeitado') {
      if (item.register?.rejected_department) {
        return item.register.rejected_department;
      }
    }

    if (status === 'Em aprovação') {
      let last_approval: Approval = item;
      if (last_approval.current_department) {
        if (last_approval.current_department.type === 'department') {
          return last_approval.current_department.department?.name || '';
        } else {
          return last_approval.current_department.agent?.name || '';
        }
      }
      if (last_approval.step > 0 && last_approval.queue?.departments) {
        return `${last_approval.step}/${last_approval.queue.departments.length}`;
      }
    }

    return '';
  }

  // Método para obter o estágio atual (nome do departamento/Compliance, etc)
  getCurrentStage(item: UserApprovalResponse): string {
    let last_approval: Approval = item;

    // Se estiver em aprovação, retorna o nome do departamento atual
    if (last_approval.current_department) {
      if (last_approval.current_department.type === 'department') {
        return last_approval.current_department.department?.name || '';
      } else {
        return last_approval.current_department.agent?.name || '';
      }
    }

    return '';
  }

  // Verificar se o registro é cotista (shareholder) usando apenas papers
  isShareholder(item: UserApprovalResponse): boolean {
    if (!item.register) {
      return false;
    }

    const registerRoles = this.getRegisterRoles(item.register);
    if (registerRoles.length > 0) {
      return registerRoles.some((role: any) => role?.applicable === 'shareholder');
    }

    return false;
  }

  // Verificar se o registro é representante usando apenas papers
  isRepresentative(item: UserApprovalResponse): boolean {
    if (!item.register) {
      return false;
    }

    const registerRoles = this.getRegisterRoles(item.register);
    if (registerRoles.length > 0) {
      return registerRoles.some((role: any) => role?.applicable === 'representative');
    }

    return false;
  }

  // Obter dados do perfil de investidor (mesma lógica do my area dashboard)
  // Prioridade: register.investor_profile > version_data.investor_profile_pf/pj
  getInvestorProfile(item: UserApprovalResponse): any {
    if (!item.register) {
      return null;
    }

    // Prioridade 1: investor_profile direto no register
    if (item.register.investor_profile) {
      return item.register.investor_profile;
    }

    // Prioridade 2: Tentar pegar do version_data (quando disponível)
    if (item.version_data) {
      // Tentar investor_profile_pf primeiro
      if (item.version_data.investor_profile_pf) {
        return item.version_data.investor_profile_pf;
      }
      // Tentar investor_profile_pj
      if (item.version_data.investor_profile_pj) {
        return item.version_data.investor_profile_pj;
      }
    }

    // Prioridade 3: Tentar pegar do register.investor_profile_pj (para PJ)
    if (
      item.register.investor_profile_pj &&
      Array.isArray(item.register.investor_profile_pj) &&
      item.register.investor_profile_pj.length > 0
    ) {
      // Pegar o perfil mais recente (maior id)
      return item.register.investor_profile_pj.reduce((prev, current) => {
        return prev.id > current.id ? prev : current;
      });
    }

    // Prioridade 4: Tentar pegar do register.investor_profile_pf (para PF)
    if (
      item.register.investor_profile_pf &&
      Array.isArray(item.register.investor_profile_pf) &&
      item.register.investor_profile_pf.length > 0
    ) {
      // Pegar o perfil mais recente (maior id)
      return item.register.investor_profile_pf.reduce((prev, current) => {
        return prev.id > current.id ? prev : current;
      });
    }

    return null;
  }

  // Obter dados de perfil de investidor/validade do registro (mesma lógica do my area dashboard)
  getInvestorProfileData(item: UserApprovalResponse): any {
    if (!this.isShareholder(item)) {
      return null;
    }

    const investorProfile = this.getInvestorProfile(item);

    // Se não tiver investor_profile, retornar null
    if (!investorProfile) {
      return null;
    }

    if (investorProfile.is_exempt === true) {
      return { is_exempt: true };
    }

    // Se not_declared é true ou profile é null, retornar dados para "Não declarado"
    if (
      investorProfile.not_declared === true ||
      investorProfile.profile === null
    ) {
      return {
        not_declared: true,
        profile: null,
      };
    }

    // Se tiver profile (1, 2 ou 3), usar valores da API ou calcular expiração
    // Profile 1 (Conservador): 2 anos
    // Profile 2 (Moderado): 1 ano
    // Profile 3 (Agressivo): 6 meses
    if (
      investorProfile.profile !== null &&
      investorProfile.profile !== undefined
    ) {
      let expireDate: Date | null = null;
      let daysUntilExpiration: number | null = null;
      let expired: boolean = false;

      // Prioridade 1: Usar valores da API se disponíveis
      if (
        investorProfile.days_to_expire !== null &&
        investorProfile.days_to_expire !== undefined
      ) {
        daysUntilExpiration = investorProfile.days_to_expire;
        expired = daysUntilExpiration < 0;

        // Se tiver expire_register, usar como expire_date
        if (investorProfile.expire_register) {
          expireDate = new Date(investorProfile.expire_register);
        }
      }
      // Prioridade 2: Calcular baseado em start_date + duração do perfil
      else if (investorProfile.start_date) {
        const startDate = new Date(investorProfile.start_date);
        expireDate = new Date(startDate);

        // Calcular duração baseada no perfil
        const profile = investorProfile.profile;
        if (profile === 1) {
          // Conservador: 2 anos
          expireDate.setFullYear(expireDate.getFullYear() + 2);
        } else if (profile === 2) {
          // Moderado: 1 ano
          expireDate.setFullYear(expireDate.getFullYear() + 1);
        } else if (profile === 3) {
          // Agressivo: 6 meses
          expireDate.setMonth(expireDate.getMonth() + 6);
        }

        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expireDate.setHours(0, 0, 0, 0);

        const diffTime = expireDate.getTime() - today.getTime();
        daysUntilExpiration = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        expired = daysUntilExpiration < 0;
      }
      // Prioridade 3: Tentar usar validity se disponível
      else if (investorProfile.validity) {
        const expirationDate = new Date(investorProfile.validity);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        expirationDate.setHours(0, 0, 0, 0);

        const diffTime = expirationDate.getTime() - today.getTime();
        daysUntilExpiration = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        expired = daysUntilExpiration < 0;
        expireDate = expirationDate;
      }

      return {
        profile: investorProfile.profile,
        not_declared: false,
        expire_date: expireDate,
        days_until_expiration: daysUntilExpiration,
        expired: expired,
        start_date: investorProfile.start_date,
        disqualification: investorProfile.disqualification || false,
      };
    }

    return null;
  }

  // Obter configuração do perfil de investidor
  getInvestorProfileConfig(profileNumber: number | null): any {
    const configs: { [key: number]: any } = {
      1: {
        type: 'Conservador',
        badgeTextColor: '#0E6027',
        badgeBackgroundColor: '#A7F0BA',
      },
      2: {
        type: 'Moderado',
        badgeTextColor: '#0043CE',
        badgeBackgroundColor: '#D0E2FF',
      },
      3: {
        type: 'Agressivo',
        badgeTextColor: '#A2191F',
        badgeBackgroundColor: '#FFD7D9',
      },
    };
    return configs[profileNumber || 0] || null;
  }

  // Obter configuração para "Não declarado"
  getNotDeclaredConfig(): any {
    return {
      type: 'Não declarado',
      badgeTextColor: '#4c4c4c',
      badgeBackgroundColor: '#ebebeb',
    };
  }

  getExemptInvestorProfileConfig(): any {
    return {
      type: 'DISPENSA POR NORMA CONF. ICVM 30, ART. 10 itens II, III ou IV',
      badgeTextColor: '#525252',
      badgeBackgroundColor: '#e0e0e0',
    };
  }

  // Obter estilo do badge de perfil de investidor
  getInvestorProfileBadgeStyle(item: UserApprovalResponse): any {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return {};
    }

    let config;
    if (data.is_exempt === true) {
      config = this.getExemptInvestorProfileConfig();
    } else if (data.not_declared === true || data.profile === null) {
      config = this.getNotDeclaredConfig();
    } else {
      config = this.getInvestorProfileConfig(data.profile);
    }

    if (!config) {
      return {};
    }

    return {
      'background-color': config.badgeBackgroundColor,
      color: config.badgeTextColor,
    };
  }

  // Obter texto do badge de perfil de investidor
  getInvestorProfileBadgeText(item: UserApprovalResponse): string {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return '';
    }

    let config;
    if (data.is_exempt === true) {
      config = this.getExemptInvestorProfileConfig();
    } else if (data.not_declared === true || data.profile === null) {
      config = this.getNotDeclaredConfig();
    } else {
      config = this.getInvestorProfileConfig(data.profile);
    }

    return config ? config.type : '';
  }

  // Obter texto de expiração
  getExpirationText(item: UserApprovalResponse): string {
    const data = this.getInvestorProfileData(item);
    if (!data) {
      return '';
    }

    if (data.is_exempt === true) {
      return '';
    }

    // Se for "Não declarado", não mostrar texto de expiração
    if (data.not_declared === true || data.profile === null) {
      return '';
    }

    const daysRemaining = data.days_until_expiration ?? 0;
    const expired = data.expired || daysRemaining < 0;

    if (expired) {
      return `Expirado há ${Math.abs(daysRemaining)} dias`;
    }

    return `Expira em ${daysRemaining} dias`;
  }

  // Verificar se está desenquadrado
  isDisqualified(item: UserApprovalResponse): boolean {
    const data = this.getInvestorProfileData(item);
    return data?.disqualification === true;
  }

  // Método para obter o label da versão
  getVersionLabel(item: UserApprovalResponse): string {
    if (item.register?.approval_version_label) {
      return item.register.approval_version_label;
    }
    const versionNumber =
      item.version_number || item.register?.approval_version_number || 1;
    return `${versionNumber}ª versão`;
  }

  // Método para obter a classe CSS do badge de versão
  getVersionBadgeClass(item: UserApprovalResponse): string {
    const versionNumber =
      item.version_number ?? item.register?.approval_version_number ?? 1;

    if (versionNumber === 1) {
      return 'version-badge-first';
    } else if (versionNumber >= 2 && versionNumber <= 5) {
      return 'version-badge-middle';
    } else {
      return 'version-badge-high';
    }
  }

  // Método para obter apenas o documento (sem prefixo CPF/CNPJ)
  getDocumentOnly(item: UserApprovalResponse): string {
    if (item.register) {
      if (item.register.type && item.register.type.toUpperCase() === 'PF') {
        return item.register.person.document
          ? this.maskPipe.transform(
              item.register.person.document.number,
              '000.000.000-00',
            )
          : '-';
      }

      if (item.register.type && item.register.type.toUpperCase() === 'PJ') {
        return item.register.company.document
          ? this.maskPipe.transform(
              item.register.company.document.number,
              '00.000.000/0000-00',
            )
          : '-';
      }
    }
    return '-';
  }

  async toggleSortButton() {
    this.sortButtonExpanded = !this.sortButtonExpanded;
    // Ativar ambos os loadings
    this.loading = true;
    this.loadingSummary = true;
    this.requestCounter++;
    const currentRequestId = this.requestCounter;
    await this.getData(1, currentRequestId, true);
    this.loading = false;
    this.loadingSummary = false;
  }

  async refreshData() {
    // Ativar ambos os loadings
    this.loading = true;
    this.loadingSummary = true;
    this.requestCounter++;
    const currentRequestId = this.requestCounter;
    await this.getData(1, currentRequestId, true);
    this.loading = false;
    this.loadingSummary = false;
  }

  getSortButtonLabel() {
    return this.sortButtonExpanded ? 'Mais antigos' : 'Mais recentes';
  }

  displayDateTime(dateStr: string) {
    if (!dateStr) return { date: '-', time: '' };

    const date = dateStr.split('T')[0].split('-');
    const hours = dateStr.split('T')[1]?.split('.')[0].split(':') || [
      '00',
      '00',
    ];

    const day = String(parseInt(date[2])).padStart(2, '0');
    const month = String(parseInt(date[1])).padStart(2, '0');
    const year = date[0];

    return {
      date: `${day}/${month}/${year}`,
      time: `às ${hours[0]}:${hours[1]}`,
    };
  }

  getCreatedDate(item: UserApprovalResponse): string {
    const dateStr = item.register?.created_at || item.created_at || null;
    if (!dateStr) return '-';
    const formatted = this.displayDateTime(dateStr);
    return formatted.date;
  }

  getCreatedTime(item: UserApprovalResponse): string {
    const dateStr = item.register?.created_at || item.created_at || null;
    if (!dateStr) return '';
    const formatted = this.displayDateTime(dateStr);
    return formatted.time;
  }

  async getFunds() {
    this.loadingFunds = true;
    try {
      const res = await this.api.get({
        route: 'api/v2/approvals/funds-dropdown/active/',
        token: true,
      });

      // A API já retorna no formato correto com label e value
      this.fundOptions = res.data || [];
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao carregar fundos de interesse');
    } finally {
      this.loadingFunds = false;
    }
  }

  setPermissions() {
    const permissions = this.authService.mapPermissionsSlugs(
      'registers',
      this.permissionObj,
    );

    const isCommonCollaborator = this.authService.isCommonCollaborator();
    const isMaster = this.authService.isMasterUser();

    permissions.forEach((permission, idx) => {
      const key = Object.keys(this.permissionObj)[idx];
      // Permitir canFilter para master e usuários comuns
      if (key === 'canFilter' && (isMaster || isCommonCollaborator)) {
        this.permissionObj[key] = true;
      }
      // Se for colaborador comum, permitir canAdd (novo cadastro)
      else if (key === 'canAdd' && isCommonCollaborator) {
        this.permissionObj[key] = true;
      } else {
        this.permissionObj[key] = this.authService.verifyPermission(permission);
      }
    });
  }

  getInitials(item: UserApprovalResponse) {
    let name = null;

    if (item.fund) {
      name = item.fund.fantasy_name;
    }

    if (item.register) {
      if (item.register.type && item.register.type.toUpperCase() === 'PF') {
        name = item.register.person?.full_name;
      }

      if (item.register.type && item.register.type.toUpperCase() === 'PJ') {
        name = item.register.company?.corporate_name;
      }
    }

    return name ? Utils.getInitials(name) : '-';
  }

  getName(item: any) {
    if ((item.user.type === 'PJ' || item.user.type === 'pj') && item.general) {
      return item.general.corporate_name;
    }

    return item.user.first_name + ' ' + item.user.last_name;
  }

  renderLink(item: UserApprovalResponse) {
    if (item.register) {
      return [
        `/app/details/${item.register?.role?.applicable}/`,
        item.register.id,
      ];
    }

    if (item.fund) {
      return [`/app/funds/approval/`, item.fund.id];
    }

    return '';
  }

  redirectTo(route: string) {
    this.router.navigate([route]);
  }

  async redirectToEdit(item) {
    // PATCH em register-step usando o register.id da URL
    await this.api.patch({
      route: `api/registration/register-step/${item.register.id}/`,
      body: { substep: 'general', step: 'register' },
      token: true,
    });

    // Redirecionar incluindo o register.id na rota
    this.router.navigate([
      `/signup/${
        item.register?.role?.applicable
      }/${item.register.type.toLowerCase()}/${item.register.id}`,
    ]);
  }

  async filterData() {
    // Ativar loading para ambas as requisições
    this.loading = true;
    this.loadingSummary = true;

    const rolesToFilter = [];
    const roles = [
      'assignor',
      'shareholder',
      'provider',
      'representative',
      'fund',
    ];

    try {
      const values = this.filterForm.value;

      const filters: any = {};

      Object.entries(values).forEach(([key, value]: any) => {
        if (value !== null && value !== '') {
          if (key === 'document') {
            filters[key] = Utils.onlyNumbers(value);
          } else if (key === 'status') {
            // Mapear status do formulário para o valor que a API espera
            if (value === 'Homologado') {
              filters.status = 'aprovado';
            } else if (value === 'Em aprovação') {
              filters.status = 'em_aprovacao';
            } else {
              filters.status = value;
            }
          } else if (key === 'expired') {
            // Converter string 'true'/'false' para boolean
            filters.expired = value === 'true' || value === true;
          } else if (key === 'risk_level') {
            filters.risk_level = value;
          } else if (key === 'has_imported') {
            // Converter boolean para true quando marcado
            filters.has_imported = value === true || value === 'true';
          } else {
            filters[key] = value;
          }
        }
      });

      // Se expired ou risk_level estiverem preenchidos, forçar role=cotista
      if (filters.expired !== undefined || filters.risk_level) {
        filters.role = 'cotista';
      } else {
        // Adicionar parâmetro role baseado na tab selecionada
        const roleParam = this.getRoleParam();
        if (roleParam) {
          filters.role = roleParam;
        }
      }

      // Construir parâmetros para a API de listagem
      let listParams = {
        type: 'register',
        page: 1,
        ...filters,
        return_distinct: true,
        order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
      };

      // A API fast retorna o summary junto com os results
      const response = await this.api.get<ApiResponse<UserApprovalResponse[]>>({
        route: `api/v3/registration/registers/fast/`,
        params: listParams,
        token: true,
      });

      const { count, results, offset } = response;
      const summaryData = (response as any).summary;

      // ✅ IMPORTANTE: hasFilters só é atualizado após aplicar os filtros com sucesso
      this.hasFilters = Object.keys(filters).length > 0;

      // Salvar os filtros na aba atual
      if (this.hasFilters) {
        // Remover o parâmetro 'role' dos filtros antes de salvar (ele é específico da aba)
        // Converter status da API de volta para o valor do formulário
        const filtersToSave = { ...filters };
        delete filtersToSave.role;
        if (filtersToSave.status) {
          // Converter de volta para o valor do formulário
          if (filtersToSave.status === 'aprovado') {
            filtersToSave.status = 'Homologado';
          } else if (filtersToSave.status === 'em_aprovacao') {
            filtersToSave.status = 'Em aprovação';
          }
        }
        // Converter expired de boolean para string 'true'/'false' para salvar no formulário
        if (filtersToSave.expired !== undefined) {
          filtersToSave.expired =
            filtersToSave.expired === true || filtersToSave.expired === 'true'
              ? 'true'
              : 'false';
        }
        this.tabFilters[this.activeTab] = filtersToSave;
      } else {
        this.tabFilters[this.activeTab] = null;
      }

      // ✅ Gerar as tags dos filtros aplicados
      this.generateFilterTags(values);

      this.dataFilters = Object.keys(filters).length > 0 ? filters : null;

      this.count = count;
      this.offset = offset;
      this.showing_to = (response as any).showing_to || 0;

      // Filtrar resultados baseado na aba ativa
      let filteredResults = results;

      // Se a aba for "all", mostrar apenas assignor, shareholder ou provider
      if (this.activeTab === 'all') {
        filteredResults = results.filter((item) => {
          if (!item.register) {
            return false; // Excluir fundos e outros tipos
          }

          const registerRoles = this.getRegisterRoles(item.register);
          if (registerRoles.length > 0) {
            // Verificar se algum role é assignor, shareholder ou provider
            return registerRoles.some(
              (role: any) =>
                role?.applicable === 'assignor' ||
                role?.applicable === 'shareholder' ||
                role?.applicable === 'provider' ||
                role?.applicable === 'representative',
            );
          }

          // Fallback: verificar role único
          const roleApplicable = item.register?.role?.applicable;
          return (
            roleApplicable === 'assignor' ||
            roleApplicable === 'shareholder' ||
            roleApplicable === 'provider' ||
            roleApplicable === 'representative'
          );
        });
      }

      // Se for Master ou Usuário Comum, não filtrar por permissões de role
      // Mostrar todos os dados retornados pela API (já filtrados por role se necessário)
      if (this.canViewTable()) {
        this.users = filteredResults;
      } else {
        // Para outros usuários, manter a lógica de filtragem por permissões
        roles.forEach((role) => {
          const slug = `de_can_view_${role}`;
          if (!this.authService.verifyPermission(slug)) {
            rolesToFilter.push(role);
          }
        });

        const filteredData = filteredResults.filter((item) => {
          return item.register
            ? !rolesToFilter.includes(item.register?.role?.applicable)
            : !rolesToFilter.includes(item.type);
        });

        this.users = filteredData;
      }

      // Atualizar estatísticas do summary (vem na resposta da API fast; API retorna "representante")
      // Total = soma dos 4 cards (cedente + cotista + prestador + representante) no front
      if (summaryData) {
        const cedente = summaryData.cedente ?? 0;
        const cotista = summaryData.cotista ?? 0;
        const prestador = summaryData.prestador ?? 0;
        const representative = summaryData.representante ?? summaryData.representative ?? 0;
        const active = summaryData.active ?? summaryData.ativos ?? 0;
        const inactive = summaryData.inactive ?? summaryData.inativos ?? 0;
        this.statistics = {
          aguardando_aprovacao: summaryData.aguardando_aprovacao ?? 0,
          homologados: summaryData.homologados ?? 0,
          cedente,
          cotista,
          prestador,
          representative,
          active,
          inactive,
          total: summaryData.total ?? 0,
        };
      }
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        'Ocorreu um erro ao carregar os dados de cedente.',
      );
      // Em caso de erro, não atualiza hasFilters
    } finally {
      // Desativar loading de ambas as requisições
      this.loading = false;
      this.loadingSummary = false;
    }
  }

  async resetForm() {
    // Ativar ambos os loadings
    this.loading = true;
    this.loadingSummary = true;
    this.hasFilters = false;
    this.appliedFilters = []; // ✅ Limpar tags
    this.filterForm.reset();
    this.dataFilters = null;

    // Limpar os filtros da aba atual
    this.tabFilters[this.activeTab] = null;

    this.requestCounter++;
    const currentRequestId = this.requestCounter;
    await this.getData(1, currentRequestId, true);
    this.loading = false;
    this.loadingSummary = false;
  }

  toggleExportOptions() {
    this.showExportOptions = !this.showExportOptions;
  }

  buildExportFilters(): any {
    const filters: any = {};
    const values = this.filterForm.value;
    const checkboxKeys = [
      'profileConservador', 'profileModerado', 'profileAgressivo', 'profileNaoAplicavel',
      'statusEmAprovacao', 'statusEmEdicao', 'statusHomologado', 'statusRejeitado',
      'estadoCadastroTodos', 'estadoCadastroAtivo', 'estadoCadastroInativo',
      'estadoTodos', 'estadoAtivo', 'estadoInativo',
    ];

    Object.entries(values).forEach(([key, value]: any) => {
      if (checkboxKeys.includes(key)) return;
      if (value !== null && value !== '' && value !== false) {
        if (key === 'document') {
          filters[key] = Utils.onlyNumbers(value);
        } else if (key === 'status') {
          if (value === 'Homologado') filters.status = 'aprovado';
          else if (value === 'Em aprovação') filters.status = 'em_aprovacao';
          else filters.status = value;
        } else if (key === 'expired') {
          filters.expired = value === 'true' || value === true;
        } else if (key === 'risk_level') {
          filters.risk_level = value;
        } else if (key === 'has_imported') {
          filters.has_imported = value === true || value === 'true';
        } else if (
          key === 'created_from' || key === 'created_to' ||
          key === 'expiry_from' || key === 'expiry_to'
        ) {
          const str = String(value || '').trim();
          if (str && str.includes('/')) {
            const parts = str.split('/');
            if (parts.length === 3) {
              const [d, m, y] = parts;
              filters[key] = `${y}-${m}-${d}`;
            } else {
              filters[key] = value;
            }
          } else if (str) {
            filters[key] = value;
          }
        } else {
          filters[key] = value;
        }
      }
    });

    const roleStatuses: string[] = [];
    if (values.statusEmAprovacao) roleStatuses.push('pending');
    if (values.statusEmEdicao) roleStatuses.push('editing');
    if (values.statusHomologado) roleStatuses.push('homologated');
    if (values.statusRejeitado) roleStatuses.push('rejected');
    if (roleStatuses.length) filters['role_status'] = roleStatuses;

    const profiles: string[] = [];
    if (values.profileConservador) profiles.push('conservative');
    if (values.profileModerado) profiles.push('moderate');
    if (values.profileAgressivo) profiles.push('aggressive');
    if (values.profileNaoAplicavel) profiles.push('not_applicable');
    if (profiles.length) filters['investor_profile'] = profiles;

    if (values.estadoCadastroAtivo) filters['registration_state'] = ['active'];
    else if (values.estadoCadastroInativo) filters['registration_state'] = ['inactive'];
    if (values.estadoAtivo) filters['role_state'] = ['active'];
    else if (values.estadoInativo) filters['role_state'] = ['inactive'];

    const roleParam = this.getRoleParam();
    if (roleParam) filters.role = roleParam;

    return {
      ...filters,
      type: 'register',
      return_distinct: true,
      order_by: this.sortButtonExpanded ? '-created_at' : 'created_at',
    };
  }

  downloadTable(format: 'csv' | 'xlsx' | 'pdf') {
    this.toggleExportOptions();
    this.exporting = true;

    const filters = this.buildExportFilters();
    const headers = this.api.getHeaders(true, true);

    const params = new HttpParams({
      fromObject: { ...filters, export: format },
    });

    this.http
      .get(
        `${this.api.url}/api/v3/registration/registers/fast/export/`,
        {
          headers: headers,
          params: params,
          responseType: 'blob',
          observe: 'response',
        }
      )
      .subscribe(
        (response: any) => {
          try {
            const blob = new Blob([response.body], {
              type:
                format === 'pdf'
                  ? 'application/pdf'
                  : format === 'csv'
                  ? 'text/csv'
                  : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const contentDisposition = response.headers.get('content-disposition');
            let fileName = `relatorio_registros.${format}`;

            if (contentDisposition) {
              const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
              if (fileNameMatch && fileNameMatch.length === 2)
                fileName = fileNameMatch[1];
            }

            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

            this.toast.show(
              'info',
              'Sucesso !',
              'Relatório gerado com sucesso!',
              null
            );
          } catch (error) {
            console.error('Erro ao baixar exportação:', error);
            this.toast.show(
              'error',
              'Erro',
              'Falha ao baixar o arquivo.',
              null
            );
          } finally {
            this.exporting = false;
          }
        },
        (error) => {
          console.error(error);
          this.toast.show(
            'error',
            'Erro',
            'Erro ao baixar o arquivo.',
            null
          );
          this.exporting = false;
        }
      );
  }

  formatDate(date: string) {
    const day = new Date(date).toLocaleDateString();
    const hours = new Date(date).toLocaleTimeString();
    return `${day} às ${hours}`;
  }

  //   setModel() {
  //     const headers = [
  //       new TableHeaderItem({ data: 'Empresa' }),
  //       new TableHeaderItem({ data: 'Papel' }),
  //       new TableHeaderItem({ data: 'Estágio atual' }),
  //     ];

  //     let newData = [];

  //     for (let user of this.users) {
  //       newData.push(
  //         new TableItem({ data: this.getDisplayName(user) }),
  //         new TableItem({ data: this.formatItemName(user) }),
  //         new TableItem({ data: this.getStatusInfo(user) })
  //       );

  //   new TableItem({
  //     data: {
  //       name: this.getDisplayName(user),
  //       document: this.getDisplayDocument(user),
  //       date: `Qtd Versões: ${
  //         user.register.current_revision
  //       } | Aprovação atualizada em ${this.formatDate(user.updated_at)}`,
  //     },
  //   });
  //     }

  //     this.model.header = headers;
  //     this.model.data = newData;
  //   }

  hasPermission(permission: string, role: string) {
    return this.authService.verifyPermission(`de_can_${permission}_${role}`);
  }

  toggleFilterModal() {
    this.showFilterModal = !this.showFilterModal;

    if (this.showFilterModal) {
      // Carregar os filtros da aba atual no formulário
      const savedFilters = this.tabFilters[this.activeTab];

      if (savedFilters) {
        // Preparar o documento formatado
        let documentFormatted = null;
        if (savedFilters.document) {
          const docLength = savedFilters.document.length;
          if (docLength === 11) {
            documentFormatted = this.maskPipe.transform(
              savedFilters.document,
              '000.000.000-00',
            );
          } else if (docLength === 14) {
            documentFormatted = this.maskPipe.transform(
              savedFilters.document,
              '00.000.000/0000-00',
            );
          } else {
            // Se não tem tamanho válido, usar o valor original
            documentFormatted = savedFilters.document;
          }
        }

        this.filterForm.patchValue({
          ...savedFilters,
          document: documentFormatted,
        });

        this.hasFilters = true;
        // Gera as tags dos filtros salvos
        this.generateFilterTags(this.filterForm.value);
      } else {
        // Se não há filtros salvos, garantir que o formulário está limpo
        this.hasFilters = false;
        this.appliedFilters = [];
      }
    }
  }

  generateFilterTags(formValues: any) {
    this.appliedFilters = [];

    const checkboxKeys = [
      'profileConservador', 'profileModerado', 'profileAgressivo', 'profileNaoAplicavel',
      'statusEmAprovacao', 'statusEmEdicao', 'statusHomologado', 'statusRejeitado',
      'estadoCadastroTodos', 'estadoCadastroAtivo', 'estadoCadastroInativo',
      'estadoTodos', 'estadoAtivo', 'estadoInativo',
    ];

    const fieldLabels: { [key: string]: string } = {
      name: 'Nome / Razão Social',
      document: 'CPF / CNPJ',
      agent: 'Agente',
      status: 'Status',
      expired: 'Validade do cadastro',
      risk_level: 'Risco',
      created_from: 'Data inicial',
      created_to: 'Data final',
      expiry_from: 'Data vencimento (de)',
      expiry_to: 'Data vencimento (até)',
      has_imported: 'Importado',
    };

    Object.entries(formValues).forEach(([key, value]: any) => {
      if (checkboxKeys.includes(key)) return;
      if (key === 'has_imported' && value !== true && value !== 'true') return;

      if (value !== null && value !== '' && value !== undefined) {
        let displayValue = value;

        if (Array.isArray(value) && value.length > 0) {
          if (key === 'agent') {
            displayValue = value
              .map((id: number) => {
                const agent = this.roleOptions.find((a) => a.value === id);
                return agent ? agent.label : id;
              })
              .join(', ');
          } else {
            displayValue = value.join(', ');
          }
        }

        if (key === 'status') displayValue = value;
        if (key === 'expired') {
          const expiredOption = this.expiredOptions.find((opt) => opt.value === value);
          displayValue = expiredOption ? expiredOption.label : value;
        }
        if (key === 'risk_level') {
          const riskOption = this.riskLevelOptions.find((opt) => opt.value === value);
          displayValue = riskOption ? riskOption.label : value;
        }
        if (key === 'has_imported') {
          displayValue = value === true || value === 'true' ? 'Sim' : 'Não';
        }

        // Datas: dd/mm/yyyy ou yyyy-mm-dd
        if (key === 'created_from' || key === 'created_to' || key === 'expiry_from' || key === 'expiry_to') {
          if (value) {
            const str = String(value);
            const iso = str.includes('/') ? str.split('/').reverse().join('-') : str;
            const date = new Date(iso);
            if (!isNaN(date.getTime())) displayValue = date.toLocaleDateString('pt-BR');
          }
        }

        if (fieldLabels[key]) {
          this.appliedFilters.push({
            label: `${fieldLabels[key]}: ${String(displayValue)}`,
            value: String(displayValue),
          });
        }
      }
    });

    // Tags para checkboxes (um tag por grupo)
    const profileLabels: string[] = [];
    if (formValues.profileConservador) profileLabels.push('Conservador');
    if (formValues.profileModerado) profileLabels.push('Moderado');
    if (formValues.profileAgressivo) profileLabels.push('Agressivo');
    if (formValues.profileNaoAplicavel) profileLabels.push('Não aplicável');
    if (profileLabels.length) {
      this.appliedFilters.push({
        label: `Perfil de investimento: ${profileLabels.join(', ')}`,
        value: profileLabels.join(', '),
      });
    }

    const statusLabels: string[] = [];
    if (formValues.statusEmAprovacao) statusLabels.push('Em aprovação');
    if (formValues.statusEmEdicao) statusLabels.push('Em edição');
    if (formValues.statusHomologado) statusLabels.push('Homologado');
    if (formValues.statusRejeitado) statusLabels.push('Rejeitado');
    if (statusLabels.length) {
      this.appliedFilters.push({
        label: `Status dos papéis: ${statusLabels.join(', ')}`,
        value: statusLabels.join(', '),
      });
    }

    if (formValues.estadoCadastroAtivo) {
      this.appliedFilters.push({ label: 'Estado do cadastro: Ativo', value: 'Ativo' });
    } else if (formValues.estadoCadastroInativo) {
      this.appliedFilters.push({ label: 'Estado do cadastro: Inativo', value: 'Inativo' });
    }

    if (formValues.estadoAtivo) {
      this.appliedFilters.push({ label: 'Estado dos papéis: Ativo', value: 'Ativo' });
    } else if (formValues.estadoInativo) {
      this.appliedFilters.push({ label: 'Estado dos papéis: Inativo', value: 'Inativo' });
    }
  }

  getCurrentPapersText(): string {
    if (!this.currentPapers || this.currentPapers.length === 0) {
      return '';
    }
    return this.currentPapers.map((p) => p.description).join(', ');
  }

  getCurrentRolesText(): string {
    if (!this.currentRole || this.currentRole.length === 0) {
      return '';
    }
    return this.currentRole
      .map((r) => r.applicable_display || r.name)
      .join(' - ');
  }

  getRolesArray(): string[] {
    if (this.currentRole && this.currentRole.length > 0) {
      return this.currentRole.map((r) => r.applicable_display || r.name);
    }
    if (this.currentPapers && this.currentPapers.length > 0) {
      return this.currentPapers.map((p) => p.description);
    }
    return [];
  }

  getRolesMessage(): string {
    const rolesArray = this.getRolesArray();

    if (rolesArray.length === 0) {
      return 'Esta pessoa já possui cadastro no sistema.';
    }

    const isPlural = rolesArray.length > 1;
    return `Esta pessoa já possui cadastro no sistema com o ${
      isPlural ? 'papéis' : 'papel'
    }:`;
  }

  getCollaboratorCompanies(): string {
    if (
      !this.collaboratorInfo ||
      !this.collaboratorInfo.companies ||
      this.collaboratorInfo.companies.length === 0
    ) {
      return '';
    }
    return this.collaboratorInfo.companies
      .map((c) => c.brand_name || c.corporate_name)
      .join(', ');
  }

  getCollaboratorDepartments(): string {
    if (
      !this.collaboratorInfo ||
      !this.collaboratorInfo.departments ||
      this.collaboratorInfo.departments.length === 0
    ) {
      return '';
    }
    return this.collaboratorInfo.departments.map((d) => d.name).join(', ');
  }

  getCollaboratorType(): string {
    if (!this.collaboratorInfo || !this.collaboratorInfo.collaborator_type) {
      return '';
    }
    const types = {
      master: 'Master',
      manager: 'Gerente',
      operator: 'Operador',
      viewer: 'Visualizador',
    };
    return (
      types[this.collaboratorInfo.collaborator_type] ||
      this.collaboratorInfo.collaborator_type
    );
  }

  getDocumentType(): string {
    const documentValue = this.newUserForm.controls.document.value;
    if (!documentValue) {
      return 'CPF / CNPJ';
    }
    const cleanDocument = Utils.onlyNumbers(documentValue);
    return cleanDocument.length === 11 ? 'CPF' : 'CNPJ';
  }

  getApprovedRolesText(): string {
    if (!this.approvedRoles || this.approvedRoles.length === 0) {
      return '';
    }
    const roleLabels = this.approvedRoles.map((role: any) => {
      const typeMap: { [key: string]: string } = {
        assignor: 'cedente',
        shareholder: 'cotista',
        provider: 'prestador de serviço',
      };
      return (
        typeMap[role.applicable] || role.applicable_display || role.applicable
      );
    });

    if (roleLabels.length === 1) {
      return roleLabels[0];
    } else if (roleLabels.length === 2) {
      return roleLabels.join(' e ');
    } else {
      const last = roleLabels.pop();
      return roleLabels.join(', ') + ' e ' + last;
    }
  }

  getCollaboratorDocument(): string {
    if (!this.collaboratorInfo || !this.collaboratorInfo.document) {
      return '';
    }
    const doc = this.collaboratorInfo.document;
    // Formatar CPF (11 dígitos) ou CNPJ (14 dígitos)
    if (doc.length === 11) {
      return doc.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (doc.length === 14) {
      return doc.replace(
        /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
        '$1.$2.$3/$4-$5',
      );
    }
    return doc;
  }

  toggleNewUserModal() {
    this.selectedApplicable = null;
    this.selectedNewUserApplicable = null;
    if (this.newUserModal) {
      this.newUserForm.reset();
      this.isCnpjDocument = false;
      // Resetar variáveis de validação de documento
      this.checkingDocument = false;
      this.documentExists = null;
      this.availablePapers = [];
      this.currentPapers = [];
      this.currentRole = [];
      this.userName = '';
      this.isCollaborator = false;
      this.collaboratorInfo = null;
      this.collaboratorMessage = '';
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      this.approvedRoles = [];
      this.documentVerified = false;
      this.showOtherFields = false;
      this.documentInviteError = null;
      this.existingRegisterId = null;
      // Resetar opções de papéis para mostrar todos
      this.updatePrimaryRoleOptions();
    }

    this.newUserModal = !this.newUserModal;
  }

  async verifyDocument() {
    const documentValue = this.newUserForm.controls.document.value;
    if (!documentValue) {
      return;
    }

    const documentClean = documentValue
      ? documentValue.replace(/[^\d]+/g, '')
      : '';

    // Resetar estado ao mudar documento
    this.documentExists = null;
    this.availablePapers = [];
    this.currentPapers = [];
    this.userName = '';
    this.isCollaborator = false;
    this.collaboratorInfo = null;
    this.collaboratorMessage = '';
    this.hasPendingApproval = false;
    this.pendingApprovalRole = '';
    this.hasInviteSent = false;
    this.inviteStatus = '';
    this.invitedData = null;
    this.hasRoleDraft = false;
    this.roleDraftInfo = null;
    this.approvedRoles = [];
    this.existingRegisterId = null;

    // Limpar erros anteriores
    this.newUserForm.controls.document.setErrors(null);

    // Verificar se o documento tem tamanho válido (CPF 11 dígitos ou CNPJ 14 dígitos)
    const isValidLength =
      documentClean.length === 11 || documentClean.length === 14;

    if (!isValidLength) {
      // Se não tem tamanho válido mas tem algum valor, limpar erros
      if (documentClean.length > 0 && documentClean.length < 11) {
        this.newUserForm.controls.document.setErrors(null);
      }
      return;
    }

    // Validar CPF ou CNPJ antes de chamar a API
    let isValid = false;
    let errorKey = '';
    if (documentClean.length === 11) {
      isValid = BrValidators.cpf(documentClean);
      errorKey = 'cpf';
    } else if (documentClean.length === 14) {
      isValid = BrValidators.cnpj(documentClean);
      errorKey = 'cnpj';
    }

    if (!isValid) {
      // Marcar campo como inválido
      this.newUserForm.controls.document.setErrors({ [errorKey]: true });
      this.newUserForm.controls.document.markAsTouched();
      return;
    }

    // Limpar erros antes de chamar API (documento válido)
    this.newUserForm.controls.document.setErrors(null);

    this.checkingDocument = true;

    try {
      const res = await this.api.post({
        route: 'validate-user-paper-exists/',
        body: { document: documentClean },
        token: true,
      });

      this.checkingDocument = false;

      // Verificar se há papéis com status diferente de "Aprovado"
      // current_role pode estar no nível raiz ou dentro de res.data
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.approvedRoles = [];

      const currentRoleRaw =
        res.current_role || (res.data && res.data.current_role);

      // Considerar todos os papéis (incluindo representante) para exibição e "tem cadastro"
      const hasValidRoles =
        currentRoleRaw &&
        Array.isArray(currentRoleRaw) &&
        currentRoleRaw.length > 0;

      if (hasValidRoles) {
        // Para travar por "em aprovação": só papéis que NÃO são representante (representante sempre homologado para efeito de bloqueio)
        const rolesForBlocking = currentRoleRaw.filter(
          (role: any) => role.applicable !== 'representative',
        );
        const pendingRole = rolesForBlocking.find(
          (role: any) => role.status && role.status !== 'Aprovado',
        );

        if (pendingRole) {
          this.hasPendingApproval = true;
          this.pendingApprovalRole = pendingRole.applicable_display || '';
        }

        // Badges e "pode adicionar papel": aprovados + representante (rep sempre conta como ok para liberar e PATCH)
        this.approvedRoles = currentRoleRaw.filter(
          (role: any) =>
            role.status === 'Aprovado' || role.applicable === 'representative',
        );
      }

      // Verificar se há convite já enviado com status sent ou viewed
      // Se for used, não bloqueia (permite outras verificações)
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;

      const invited = res.invited || (res.data && res.data.invited);
      if (invited && invited.status) {
        const inviteStatus = invited.status;
        if (inviteStatus === 'sent' || inviteStatus === 'viewed') {
          this.hasInviteSent = true;
          this.inviteStatus = inviteStatus;
          this.invitedData = invited; // Armazenar dados completos do convite
        }
      }

      // Verificar se há role_draft (adição de papel em andamento)
      // Se role_draft existir (não for null/undefined), significa que há adição de papel em andamento
      // role_draft pode estar no nível raiz ou dentro de res.data
      const roleDraft = res.role_draft || (res.data && res.data.role_draft);

      this.hasRoleDraft = false;
      this.roleDraftInfo = null;

      if (roleDraft !== null && roleDraft !== undefined) {
        // Sempre travar quando houver role_draft, independentemente de estar aprovado
        // Se há role_draft, significa que há uma adição de papel em andamento
        this.hasRoleDraft = true;
        this.roleDraftInfo = roleDraft;
        // Quando há role_draft, bloquear o cadastro
        this.documentExists = true;
        // Definir userName se disponível
        if (res.name || (res.data && res.data.name)) {
          this.userName = res.name || res.data.name;
        }
      }

      // Verificar se é um colaborador
      if (res.is_collaborator && res.collaborator) {
        this.isCollaborator = true;
        this.collaboratorInfo = res.collaborator;
        this.collaboratorMessage = res.message || '';
        this.documentExists = true; // Bloquear cadastro

        // Se houver aprovação pendente, também definir userName se disponível
        if (res.data && res.data.name) {
          this.userName = res.data.name;
        } else if (res.name) {
          // Capturar nome diretamente de res.name se disponível
          this.userName = res.name;
        }
      } else {
        this.isCollaborator = false;
        this.collaboratorInfo = null;
        this.collaboratorMessage = '';
        this.documentExists = hasValidRoles && res.exists === true;

        if (this.documentExists && res.data) {
          this.userName = res.data.name || res.name || '';
          this.availablePapers = res.data.papers || [];
          this.currentPapers = res.data.current_papers || [];
          this.currentRole = res.data.current_role || [];
          // Armazenar register_id se disponível (paper exists já pode devolver o uuid em data.id)
          this.existingRegisterId =
            res.data.register_id ||
            res.data.id ||
            res.register_id ||
            res.id ||
            null;
        } else if (this.documentExists && res.name) {
          this.userName = res.name;
        } else if (res.name && this.approvedRoles.length > 0) {
          // Se não documentExists mas tem papéis aprovados, definir userName
          this.userName = res.name;
        } else if (res.name) {
          // Se houver nome na resposta, definir userName mesmo sem documentExists
          this.userName = res.name;
        }
      }

      // Se houver aprovação pendente, convite já enviado ou role_draft, bloquear cadastro
      if (this.hasPendingApproval || this.hasInviteSent || this.hasRoleDraft) {
        this.documentExists = true;
        // Se houver convite enviado mas não houver userName, tentar pegar da mensagem ou definir como vazio
        if (this.hasInviteSent && !this.userName && res.message) {
          // A mensagem pode conter informações úteis, mas não vamos definir userName aqui
        }
        // Se houver role_draft mas não houver userName, pegar do res.name
        if (this.hasRoleDraft && !this.userName && res.name) {
          this.userName = res.name;
        }
      }

      // Se passou em todas as validações (não é colaborador, não tem aprovação pendente, não tem convite enviado, não tem role_draft)
      // e o documento foi verificado, mostrar os campos para preenchimento
      // Isso acontece quando exists = false OU quando exists = true e tem papéis que permitem adicionar outro (aprovados ou representante)
      if (
        !this.checkingDocument &&
        !this.isCollaborator &&
        !this.hasPendingApproval &&
        !this.hasInviteSent &&
        !this.hasRoleDraft
      ) {
        if (
          res.exists === false ||
          (res.exists === true && this.approvedRoles.length > 0) ||
          (res.exists === true && !hasValidRoles)
        ) {
          this.documentVerified = true;
          this.showOtherFields = true;

          // Atualizar opções de papéis filtradas por tipo de documento e papéis já aprovados
          this.updatePrimaryRoleOptions(documentClean);

          // Armazenar register_id se disponível (paper exists já devolve o uuid em data.id ou data.register_id)
          if (res.exists === true && this.approvedRoles.length > 0) {
            this.existingRegisterId =
              res.data?.register_id ||
              res.data?.id ||
              res.register_id ||
              res.id ||
              null;

            // Se não tiver register_id na resposta, buscar pelo documento
            if (!this.existingRegisterId && documentClean) {
              try {
                const registerResponse = await this.api.get<any>({
                  route: `api/v3/registration/registers/`,
                  params: {
                    document: documentClean,
                    type: 'register',
                  },
                  token: true,
                });

                // Pegar o primeiro resultado (deve haver apenas um register por documento)
                if (
                  registerResponse?.results &&
                  registerResponse.results.length > 0
                ) {
                  const first = registerResponse.results[0];
                  this.existingRegisterId =
                    (first?.id ?? first?.register?.id)?.toString() ?? null;
                }
              } catch (error) {
                console.error('Erro ao buscar register pelo documento:', error);
                // Continuar sem register_id, o fluxo normal de criação será usado
              }
            }
          }

          // Preencher o campo full_name se houver nome disponível
          if (this.userName) {
            this.newUserForm.controls.full_name.setValue(this.userName);
          }

          // Preencher o campo email se houver email disponível na resposta
          const email = res.email || (res.data && res.data.email);
          if (email) {
            this.newUserForm.controls.email.setValue(email);
          }
        }
      }
    } catch (error) {
      console.error('Erro ao validar documento:', error);
      this.checkingDocument = false;
      this.documentExists = null;
      this.isCollaborator = false;
      this.collaboratorInfo = null;
      this.collaboratorMessage = '';
      this.hasPendingApproval = false;
      this.pendingApprovalRole = '';
      this.hasInviteSent = false;
      this.inviteStatus = '';
      this.invitedData = null;
      this.hasRoleDraft = false;
      this.roleDraftInfo = null;
      this.approvedRoles = [];
      this.existingRegisterId = null;
    }
  }

  async registerNewUser() {
    // Marcar todos os campos como touched para mostrar erros de validação
    this.newUserForm.markAllAsTouched();

    // Se o formulário for inválido, não prosseguir
    if (this.newUserForm.invalid) {
      return;
    }

    const ids = {
      user: this.authService.user.active_register.id,
      register_id: this.authService.user.active_register.register.id,
    };
    this.storageService.setEditUser(ids);

    this.sendingRequest = true;

    try {
      const selectedRole = this.roles.find(
        (item) => item.id === Number(this.newUserForm.value.role),
      );

      const type = selectedRole.slug.split('-')[1]?.toUpperCase();
      const applicable = selectedRole.applicable;

      // Limpar o documento (remover formatação)
      const documentClean = this.newUserForm.value.document
        ? this.newUserForm.value.document.replace(/[^\d]+/g, '')
        : '';

      // Verificar se estamos adicionando papel a um usuário existente
      if (this.existingRegisterId && this.approvedRoles.length > 0) {
        // Fluxo: Adicionar papel a usuário existente
        // 1. Fazer PATCH para adicionar role_draf

        try {
          await this.api.patch({
            route: `api/v3/registration/registers/`,
            body: {
              register_uuid: this.existingRegisterId,
              role_draft: selectedRole.id,
            },
            token: true,
          });

          // Guardar o id do papel selecionado no storage para usar no sendApproval
          this.storageService.set('selected_role_id', selectedRole.id, true);

          // 2. PATCH no register-step para definir o trace step
          await this.api.patch({
            route: `api/registration/register-step/${this.existingRegisterId}/`,
            body: { substep: 'general', step: 'register' },
            token: true,
          });

          // 3. Determinar o type baseado no documento (CPF = PF, CNPJ = PJ)
          const registerType = documentClean.length === 11 ? 'pf' : 'pj';

          // 4. Redirecionar para a página de cadastro
          this.newUserForm.reset();
          this.newUserModal = false;
          this.sendingRequest = false;

          this.router.navigate([
            `/signup/${applicable}/${registerType}/${this.existingRegisterId}`,
          ]);

          return;
        } catch (error) {
          console.error('Erro ao adicionar role_draft:', error);
          this.toast.show(
            'error',
            'Erro!',
            'Erro ao adicionar papel ao usuário existente',
          );
          this.sendingRequest = false;
          return;
        }
      }

      // Fluxo normal: Criar novo cadastro
      const payload: any = {
        role: selectedRole.id,
        type,
        status: 'created',
      };

      // Adicionar email se existir
      if (this.newUserForm.value.email) {
        payload.email = this.newUserForm.value.email;
      }

      // Adicionar interest_fund apenas se existir
      if (this.newUserForm.value.interest_fund) {
        payload.interest_fund = this.newUserForm.value.interest_fund;
      }

      // Se for PJ, usar company; se for PF, usar person
      if (type === 'PJ') {
        payload.company = {
          corporate_name: this.newUserForm.value.full_name || '',
          document: {
            number: documentClean,
          },
        };
      } else {
        payload.name = this.newUserForm.value.full_name || '';
        payload.person = {
          full_name: this.newUserForm.value.full_name || '',
          document: {
            number: documentClean,
          },
        };
      }

      if (this.newUserForm.value.agent) {
        payload['agent'] = this.newUserForm.value.agent;
      }

      const res = await this.api.post({
        route: 'api/registration/register/',
        token: true,
        body: payload,
      });

      this.storageService.setNewUserData({
        ...payload,
        document: this.newUserForm.value.document,
        role: this.newUserForm.value.agent,
      });

      this.newUserForm.reset();
      this.newUserModal = false;

      this.sendingRequest = false;

      // Redirecionamento direto com os dados que já temos
      const registerId = res.data.id;
      // Usar o type da resposta da API ao invés do extraído do slug, pois pode estar mais correto
      const typeFromResponse = res.data.type
        ? res.data.type.toLowerCase()
        : type.toLowerCase();
      const typeLower = typeFromResponse;

      this.router.navigate([
        `/signup/${applicable}/${typeLower}/${registerId}`,
      ]);
    } catch (error) {
      this.toast.show('error', 'Erro!', 'Erro ao cadastrar usuário');
      this.sendingRequest = false;
    }
  }

  async getAccounts(type: string = 'profile', register_id: string = null) {
    try {
      const { data } = await this.api.get<ApiResponse<RegisterUserResponse[]>>({
        route: `api/registration/register_user/`,
        params: {
          type: type,
          register: register_id,
        },
        token: true,
      });

      this.accounts = data
        .sort((a, b) => {
          return (
            new Date(b.register.created_at).getTime() -
            new Date(a.register.created_at).getTime()
          );
        })
        .reverse();

      this.authService.accountsArr = this.accounts;
    } catch (error) {
      console.error(error);
    }
  }

  async changeActiveRegister(id: number) {
    try {
      await this.api.patch({
        route: `user/me/`,
        token: true,
        body: {
          active_register: id,
        },
      });

      const { data } = await this.api.get<ApiResponse<NewLoginResponse>>({
        route: 'user/me/',
        token: true,
      });

      this.storageService.setPermissionType(data.type_permission);
      this.authService.setUser(data);

      //   let permissionsArr =
      //     data.active_register.permissions_role &&
      //     data.active_register.permissions_role.permissions.length > 0
      //       ? data.active_register.permissions_role.permissions
      //       : permission;

      //   if (data.active_register.register.role.applicable === 'representative') {
      //     const defaultPermissions: Permission[] = permission;

      //     permissionsArr = permissionsArr.concat(defaultPermissions);
      //   }

      //   this.authService.permissions = permissionsArr;
      //   this.storageService.set('permissions', permissionsArr, true);
      this.handleRedirect(id);
    } catch (error) {
      console.error(error);
      this.toast.show('error', 'Erro!', 'Erro ao alterar conta ativa');
    }
  }

  handleRedirect(id: number, visible_accounts: boolean = true) {
    const account = this.isAccounts
      ? this.accounts.find((item) => item.id === id)
      : this.visible_accounts.find((item) => item.id === id);

    const isApprover = account.register.is_approver;
    const applicable = account.register.role.applicable;
    const approvals = account.register.approval;
    const _id = account.register.id;
    const type = account.register?.type?.toLowerCase() || '';

    this.isAccounts = false;

    if (applicable === 'representative' || applicable === 'admin') {
      this.router.navigate(['/app/dashboard']);
      return;
    }

    if (approvals.length > 0) {
      if (isApprover) {
        this.router.navigate(['/app/dashboard']);
      } else {
        this.router.navigate([`/app/details/${applicable}/`, _id]);
      }
    } else {
      this.router.navigate([`/signup/${applicable}/${type}`]);
    }
  }
}
